import React from "react";
import {
  Accordion,
  ActionIcon,
  Avatar,
  Badge,
  Box,
  Button,
  Checkbox,
  Divider,
  Drawer,
  Flex,
  Grid,
  Group,
  Modal,
  Popover,
  Radio,
  ScrollArea,
  Select,
  SimpleGrid,
  Text,
  TextInput,
  Textarea,
  rem,
} from "@mantine/core";
import { DateInput, TimeInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useMediaQuery } from "@mantine/hooks";
import { IconClock, IconInfoCircle } from "@tabler/icons-react";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  createNote,
  editNote,
  getSingleNote,
  updateNoteStatus,
} from "../../services/note";
import { getAllPatientsModal } from "../../services/patient";
import swal from "sweetalert";

import {
  decrypt,
  formatDate,
  formatTime,
  getOptions,
  noteType_Client,
  noteType_Client_Options,
} from "../../utils";
import useStyles from "./styles";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg";
import { IconX } from "@tabler/icons-react";
import { RxCross1, RxCross2 } from "react-icons/rx";
import { IconChevronDown } from "@tabler/icons-react";
import { getPendingActions, getPendingNotes, getTodaysNotes } from "../../services/dashboard";
import { MdPendingActions } from "react-icons/md";
import {
  Billing_Services_Note,
  Essential_Support_Note,
  Intervention_Progress_Note,
  Group_Note,
  PROGRESS_Note,
} from "../../http";
import { planTypeLabels } from "../MAR/ClientSupportPlans";
import ViewInfo from "./ViewInfo";
import EssentialViewInfo from "./EssentialViewInfo";
import {
  LuBookOpen,
  LuMapPin,
  LuUsers,
  LuFileText,
  LuPlus,
  LuPower,
  LuBell,
  LuInfo,
  LuShieldCheck,
  LuHeart,
  LuStethoscope,
  LuTarget,
  LuPenLine,
} from "react-icons/lu";
import { IoMdCheckboxOutline } from "react-icons/io";
import moment from "moment";
import SignaturePadField from "../SignaturePadField";
import StudioSectionsForm from "./StudioSectionsForm";

const NoteModalNew = ({
  opened,
  close,
  title,
  view,
  hideApproveRejectButtons,
  onApprovalChanged,
  setView,
  userId, //clientId
  noteType: NOTETYPE,
  ...data
}) => {
  // Get the current time in HH:mm:ss format
  const noteData = data;
  const { classes } = useStyles();
  const ref = useRef();
  const edit = data.data ? true : false;
  const noteT = data?.data?.noteId;
  const { allNotesTypes, addNoteLoading } = useSelector((state) => state?.note);
  const { allPlans } = useSelector((state) => state?.supportPlan);
  const { profile } = useSelector((state) => state.profile);
  const { allPatients } = useSelector((state) => state?.patient);
  const [errors, setErrors] = useState({});
  const { allSignature } = useSelector((state) => state?.signature);

  const patientInfo = allPatients?.map((patient) => {
    return {
      selectedPatientId: patient?.id,
      label: patient?.name,
    };
  });

  const [medicationOptions, setMedicationOptions] = useState([]);
  const [supportOptions, setSupportOptions] = useState([]);
  const [outComeTitle, setOutComeTitle] = useState([]);
  const [outcomeNumbers, setOutComeNumbers] = useState([]);
  const [outcomeNotes, setOutcomeNotes] = useState([]);

  const [essentialNotes, setEssentialNotes] = useState([]);
  const [savePlanId, setSavePlanId] = useState("");

  const [essentialSupportType, setEssentialSupportType] = useState([]);
  const [essentialSupportNumber, setEssentialSupportNumber] = useState([]);

  const [displayAccordionTitle, setDisplayAccordionTitle] = useState(false);
  const [noteType, setNoteType] = useState(
    noteT
      ? allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id)
      : allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE)
  );
  const [selectedPatient, setSelectedPatient] = useState(null);
  const id = selectedPatient?.id;
  const clientId = id?.slice(-6);
  const [patientsId, setPatientsId] = useState(null);
  const isFacilityDisabled = noteType?.custom?.find((value) => {
    return (
      value?.fieldType?.name?.toLowerCase() ===
      noteType_Client_Options?.toLowerCase()
    );
  });

  const isMobileScreen = useMediaQuery("(max-width: 600px)");
  const [supportPlan, setSupportPlan] = useState("no");
  const [essentialSupportToggle, setEssentialSupportToggle] = useState("no");
  const [interventionPlanToggle, setInterventionPlanToggle] = useState("no");

  const [serviceNumber, setServiceNumber] = useState(null);

  const [reasonError, setReasonError] = useState("");

  // Incident Report approval requires the supervisor's signature — this holds
  // the inline "signature required" message shown under the signature pad.
  const [signatureError, setSignatureError] = useState("");

  const [essentialAccordion, setEssentialAccordion] = useState("0");
  const [goalsAccordion, setGoalsAccordion] = useState("0");

  const [essentialSupportCount, setEssentialSupportCount] = useState([]);

  const [noteRejectValue, setNoteRejectValue] = useState(null);
  const [noteRejectionDescp, setNoteRejectionDescp] = useState("");

  const [showRejection, setShowRejection] = useState(false);
  const [showRejectedNote, setShowRejectedNote] = useState(false);
  const [showApproved, setShowApproved] = useState(false);

  const [selectedFacility, setSelectedFacility] = useState();

  const icon = <DropDownArrowSvg style={{ width: rem(1), height: rem(1) }} />;

  // Always name the record by its real type ("Incident Report", "Progress
  // Note", …) in user-facing copy rather than a generic "note".
  const noteLabel = noteType?.name || data?.data?.noteId?.name || "Note";
  const isIncidentReport = noteLabel === "Incident Report";

  // Reviewing and signing an incident report is an admin / Supervisor action.
  const isSupervisorAdmin =
    profile?.user?.role === "admin" || !profile?.user?.type;
  // The pad holds the drawn/typed/uploaded signature locally; it is uploaded
  // and stored as part of the Approve action, not on its own request.
  const incidentSignatureRef = useRef(null);

  // A note-type template can restrict approval to specific admins
  // (templateSettings.allApprovers === false + a non-empty approvers list).
  // When restricted, only those admins (or a superadmin) may approve/reject —
  // everyone else sees the note read-only. allApprovers === true keeps the
  // default (any admin can approve). The backend enforces this too.
  const canApprove = useMemo(() => {
    const ts = noteType?.templateSettings || {};
    const approvers = Array.isArray(ts.approvers) ? ts.approvers.map(String) : [];
    const restricted = ts.allApprovers === false && approvers.length > 0;
    if (!restricted) return true;
    if (profile?.user?.role === "superadmin") return true;
    return approvers.includes(String(profile?.user?.id));
  }, [noteType?.templateSettings, profile?.user?.id, profile?.user?.role]);

  // Incident Reports always need a Supervisor sign-off, so their Approve /
  // Reject controls stay visible even where the host screen hides them for
  // ordinary notes (the notes list passes hideApproveRejectButtons).
  const showApprovalControls = (!hideApproveRejectButtons || isIncidentReport) && canApprove;

  const isBilling_Services = noteType?.id === Billing_Services_Note;
  // A user-authored Note-Type Studio template renders read-only from its rich
  // `sections[]` model so a viewed note shows every field it was built with.
  const isSpecialNoteType =
    [Essential_Support_Note, Billing_Services_Note, Intervention_Progress_Note, Group_Note, PROGRESS_Note].includes(noteType?.id) ||
    noteType?.name === "Incident Report" ||
    noteType?.name === "Progress Note";
  const isStudioTemplate =
    !isSpecialNoteType &&
    Array.isArray(noteType?.sections) &&
    noteType.sections.length > 0;
  const [goalOptions, setGoalOptions] = useState([]);
  const [goalItems, setGoalItems] = useState([
    [{ id: Date.now(), objectives: "", Intervention_Instruction: "" }],
  ]);

  const initialDescription = {
    outcomeTitle: "",
    outcomeNumber: "",
    outComeCategory: "",
    description: "",
    details: null,
    error: "",
  };

  const initialEssentialSupport = {
    id: Date.now(),
    essentialSupportType: "",
    essentialActivityNumber: "",
    description: "",
  };

  const initialGoals = {
    id: Date.now(),
    goalNumber: "",
    goalNote: "",
    startTimeGoal: "",
    endTimeGoal: "",
    goalActivities: [
      { id: Date.now(), objectives: "", Intervention_Instruction: "" },
    ],
    behaviorDescription: "",
    responseDescription: "",
    planDescription: "",
  };

  const [descriptions, setDescriptions] = useState([
    { id: 1, ...initialDescription },
  ]);

  const [essentialSupport, setEssentialSupport] = useState([
    { id: 1, ...initialEssentialSupport },
  ]);

  const [goals, setGoals] = useState([{ id: 1, ...initialGoals }]);

  React.useEffect(() => {
    setDescriptions([{ id: 1, ...initialDescription }]);
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    setGoals([{ id: 1, ...initialGoals }]);
  }, []);

  useEffect(() => {
    setShowRejectedNote(false);
    setShowRejection(false);
  }, [noteData?.data?.approvalStatus]);

  const [goalNumber, setGoalNumbers] = useState([]);
  // const [goalActivities, setGoalActivities] = useState([]);
  const [objectivesByGoal, setObjectivesByGoal] = useState([]);
  const [interventionsByGoal, setInterventionsByGoal] = useState([]);

  useEffect(() => {
    let outcomeTitle = [];
    let outcomeNumberArray = [];
    let essentialSupportArray = [];
    let essentialSupportNumber = [];
    let planIdToSave = null;
    let objectivesMap = [];
    let goalTitleOptions = [];
    let goalNumberOptions = [];
    let interventionsMap = [];

    if (noteType?.name === "Intervention Progress Note") {
      const filteredGoals = selectedPatient
        ? allPlans
            ?.filter(
              (v) =>
                v?.client?._id === selectedPatient?.id &&
                v?.facility?._id === selectedFacility
            )
            ?.map((v) => {
              v?.goals?.map((goal) => {
                if (edit) {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    goalTitleOptions.push({
                      value: goal?.Identified_Relevant_Attainable_Goals,
                      label: goal?.Identified_Relevant_Attainable_Goals,
                    });

                    goalNumberOptions.push({
                      value: goal?.goalNumber,
                      label: goal?.goalNumber,
                    });

                    // goal.goalActivities?.map((act) =>
                    //   objectivesMap.push({
                    //     value: act.objectives,
                    //     label: act.objectives,
                    //   })
                    // );

                    // goal.goalActivities?.map((act) =>
                    //   interventionsMap.push({
                    //     value: act.Intervention_Instruction,
                    //     label: act.Intervention_Instruction,
                    //   })
                    // );
                  }
                } else {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    goalTitleOptions.push({
                      value: goal?.Identified_Relevant_Attainable_Goals,
                      label: goal?.Identified_Relevant_Attainable_Goals,
                      disabled: goal.hasOwnProperty("isActive")
                        ? !goal?.isActive
                        : false,
                    });

                    goalNumberOptions.push({
                      value: goal?.goalNumber,
                      label: goal?.goalNumber,
                      disabled: goal.hasOwnProperty("isActive")
                        ? !goal?.isActive
                        : false,
                    });

                    // goal.goalActivities?.map((act) =>
                    //   objectivesMap.push({
                    //     value: act.objectives,
                    //     label: act.objectives,
                    //   })
                    // );

                    // goal.goalActivities?.map((act) =>
                    //   interventionsMap.push({
                    //     value: act.Intervention_Instruction,
                    //     label: act.Intervention_Instruction,
                    //   })
                    // );
                  }
                }
              });
              return v;
            })
        : [];
    } else {
      const filtered = selectedPatient
        ? allPlans
            ?.filter(
              (v) =>
                v?.client?._id === selectedPatient?.id &&
                v?.facility?._id === selectedFacility
            )
            ?.map((v) => {
              v?.outcomes?.map((vv) => {
                // If block is for edit and else block is for add
                if (edit) {
                  // Check if care plan is acive or discontinued
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    // if care plan is active then push all the outcomes
                    outcomeTitle.push({
                      value: vv?.id,
                      label: vv?.outcomeTitle,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    outcomeNumberArray.push({
                      value: vv?.id,
                      label: vv?.outcomeNumber,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });

                    if (v?.planType?.planId) {
                      planIdToSave = v?.planType?.planId;
                    }
                    // essential support details
                    if (v?.essentialSupport) {
                      if (v?.essentialSupport?.length > 0) {
                        // setEssentialSupport(v?.essentialSupport);
                        setEssentialSupportCount(v?.essentialSupport);
                        // setEssentialAccordion("1");
                      }
                    }
                  } else if (
                    v?.status === "discontinued" &&
                    v?.isActive === false
                  ) {
                    // if care plan is discontinued then check if one of its outcome is used while creating progress note
                    let filteredDesc = data?.data?.descriptions?.filter(
                      (_d) => _d?.outcomeNumber === vv?.id
                    );

                    if (filteredDesc?.length > 0) {
                      // if outcome is used then push the outcome
                      outcomeTitle.push({
                        value: vv?.id,
                        label: `${vv?.outcomeTitle} (D)`,
                        disabled: true,
                      });
                      outcomeNumberArray.push({
                        value: vv?.id,
                        // label: <p>{vv?.outcomeNumber} <b>(D)</b></p>,
                        label: `${vv?.outcomeNumber} (D)`,
                        disabled: true,
                      });
                    }
                  }
                } else {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    outcomeTitle.push({
                      value: vv?.id,
                      label: vv?.outcomeTitle,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    outcomeNumberArray.push({
                      value: vv?.id,
                      label: vv?.outcomeNumber,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    // If planType is present then save the planId to state for labels
                    if (v?.planType?.planId) {
                      planIdToSave = v?.planType?.planId;
                    }
                    // essential support details
                    if (v?.essentialSupport) {
                      if (v?.essentialSupport?.length > 0) {
                        // setEssentialSupport([v?.essentialSupport[0]]);
                        setEssentialSupportCount(v?.essentialSupport);
                      }
                    }
                    return v;
                  }
                }
              });

              if (
                v?.status === "active" &&
                v?.isActive === true &&
                v?.deleted !== true
              ) {
                v?.essentialSupport?.map((vv) => {
                  essentialSupportArray.push({
                    value: vv?.id,
                    label: vv?.essentialSupportType,
                  });

                  vv?.activities?.map((_a) => {
                    essentialSupportNumber.push({
                      value: _a?.id,
                      label: _a?.supportStatement,
                    });
                  });
                });
              }
            })
        : [];
    }

    setObjectivesByGoal(objectivesMap);
    setInterventionsByGoal(interventionsMap);

    setGoalOptions(goalTitleOptions);
    setGoalNumbers(goalNumberOptions);
    // setGoalActivities(goalActivities

    // Set the planId to the state
    if (planIdToSave) {
      setSavePlanId(planIdToSave);
    }
    setEssentialSupportNumber(essentialSupportNumber);
    setEssentialSupportType(essentialSupportArray);
    setOutComeTitle(outcomeTitle || []);
    setOutComeNumbers(outcomeNumberArray || []);
    if (selectedPatient) {
      let serviceNumber = selectedPatient?.form1?.services?.filter(
        (i) => i?.servicenumber == data?.data?.fields["Service Type"]
      )?.[0];
      setServiceNumber(serviceNumber);
    }
  }, [selectedPatient, allPlans, selectedFacility]);

  // useEffect(() => {
  // }, [selectedFacility]);

  //  useEffect(() => {
  //   if (noteData) {
  //     const allActivities = noteData?.data?.goals?.map((goal) => goal?.goalActivities || []) || [];
  //     setGoalItems(allActivities);
  //   }
  // }, []);

  let getGoalsData = data?.data?.goals;
  // Replace the existing useEffect with this updated version
  useEffect(() => {
    if (noteData) {
      // // Extract goal activities from all goals
      const allActivities =
        noteData?.data?.goals?.flatMap((goal) => goal?.goalActivities || []) ||
        [];

      // // Set goal items for display
      // setGoalItems(allActivities);

      let finalGoalItems = [];

      getGoalsData?.map((_g, index) => {
        finalGoalItems.push(_g.goalActivities);
      });

      setGoalItems(finalGoalItems);

      const formattedObjectives = allActivities?.map((_ga) => ({
        label: _ga.objectives,
        value: _ga.objectives,
      }));

      setObjectivesByGoal(
        formattedObjectives.length > 0 ? formattedObjectives : []
      );

      const formattedInterventions = allActivities?.map((_ga) => ({
        label: _ga.Intervention_Instruction,
        value: _ga.Intervention_Instruction,
      }));

      setInterventionsByGoal(
        formattedInterventions.length > 0 ? formattedInterventions : []
      );
    }
  }, []);

  // // Add New Outcome Handler
  const addDescription = () => {
    if (descriptions?.length < outComeTitle?.length) {
      setDescriptions([
        ...descriptions,
        { id: Date.now(), ...initialDescription },
      ]);
      // setDisplayAccordionTitle(false);
      setOpenedAccordion(`${descriptions?.length}`);
    }
  };

  // // Add New Essential Support Handler
  const addEssentialSupport = () => {
    if (essentialSupport?.length < essentialSupportCount?.length) {
      setEssentialSupport([
        ...essentialSupport,
        {
          id: Date.now(),
          ...initialEssentialSupport,
          // ...essentialSupportCount[essentialSupport?.length],
        },
      ]);
      setEssentialAccordion(`${essentialSupport?.length - 1}`);
    }
  };

  const removeMedication = (medicationId) => {
    setDescriptions(descriptions.filter((med) => med.id !== medicationId));
  };

  // Remove Essential Support Handler
  const removeEssentialSupport = (medicationId) => {
    const filtered = essentialSupport?.filter((med) => {
      return med.id !== medicationId;
    });
    setEssentialSupport(filtered);
  };

  const handleEssentialChange = (supportId, field, value, indexx) => {
    let filtered_plan_1 = allPlans?.filter(
      (v) =>
        v?.client?._id === selectedPatient?.id &&
        v?.facility?._id === selectedFacility
    );

    let selectedEsType = [];
    let selectedActivityId = null;

    filtered_plan_1?.map((_fp) => {
      _fp?.essentialSupport?.map((_es) => {
        if (_es?.activities?.find((_a) => _a?.id == value)) {
          selectedEsType.push(_es);
        }
      });
    });

    setEssentialSupport((prev) =>
      prev?.map((item, index) => {
        if (index === indexx) {
          return item.id === supportId
            ? { ...selectedEsType?.[0], essentialActivityNumber: value }
            : item;
        } else {
          return item;
        }
      })
    );
  };

  // add note of respective essential plan
  const handleEssentialSupportDesc = (supportId, field, value, indexx) => {
    setEssentialSupport((prev) =>
      prev?.map((item, index) => {
        if (index === indexx) {
          return item.id === supportId ? { ...item, [field]: value } : item;
        } else {
          return item;
        }
      })
    );
  };

  const handleMedicationChange = (medicationId, field, value) => {
    let filteredObj = null;

    if (field === "outcomeTitle") {
      filteredObj = outComeTitle?.filter((item) => item?.value === value)?.[0];
    } else if (field === "outcomeNumber") {
      filteredObj = outcomeNumbers?.filter(
        (item) => item?.value === value
      )?.[0];
    }

    setDisplayAccordionTitle(field);
    let previous = descriptions?.find(
      (v) => v?.outcomeTitle === value || v?.outcomeNumber === value
    );
    let rest = {};
    if (field === "outcomeTitle" || field === "outcomeNumber") {
      let { id, ...others } = allPlans
        ?.find((v) => v?.client?._id === selectedPatient?.id)
        ?.outcomes?.find((v) => v?.id === value);
      rest = others;
    }

    setDescriptions((prevMedications) =>
      prevMedications.map((med, index) => {
        if (field !== "metGoal" && field !== "description") {
          return med.id === medicationId
            ? {
                ...med,
                ...(outcomeNotes[index]?.length > 0 && {
                  description: outcomeNotes[index],
                }),
                [field]: value,
                [field == "outcomeTitle" ? "outcomeNumber" : "outcomeTitle"]:
                  filteredObj?.value,
                outComeCategory:
                  field === "outcomeTitle" || field === "outcomeNumber"
                    ? allPlans
                        ?.find((v) => v?.client?._id === selectedPatient?.id)
                        ?.outcomes?.find((v) => v?.id === value)
                        ?.outcomeCategory
                    : med?.outComeCategory,
                details:
                  field === "outcomeTitle" || field === "outcomeNumber"
                    ? filterNonNullFields(rest)
                    : med?.details,
                error: previous ? "Already Selected" : null,
              }
            : med;
        } else {
          return med.id === medicationId
            ? {
                ...med,
                [field]: value,
                outComeCategory:
                  field === "outcomeTitle" || field === "outcomeNumber"
                    ? allPlans
                        ?.find((v) => v?.client?._id === selectedPatient?.id)
                        ?.outcomes?.find((v) => v?.id === value)
                        ?.outcomeCategory
                    : med?.outComeCategory,
                details:
                  field === "outcomeTitle" || field === "outcomeNumber"
                    ? filterNonNullFields(rest)
                    : med?.details,
                error: previous ? "Already Selected" : null,
              }
            : med;
        }
      })
    );
    setErrors("");
  };

  const handleShowRejection = () => {
    setShowRejection(false);
    setNoteRejectValue(null);
    setNoteRejectionDescp("");
    setReasonError("");
  };

  const resetForm = () => {
    setErrors("");
    setSignatureError("");
    form.reset();
    setShowRejectedNote(false);
    setShowApproved(false);
    setShowRejection(false);
    setNoteRejectValue(null);
    setNoteRejectionDescp("");
    setEssentialNotes([]);
    setEssentialSupportToggle(false);
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    // setNoteType(null);
    setPatientsId(null);
    setSelectedPatient(null);
    close();
  };

  const onSave = (values) => {
    let obj = {
      noteId: NOTETYPE,
      fields: { ...values, noteId: NOTETYPE },
      supportPlan,
      userId,
    };
    const isProgressNote = noteType?.name === "Progress Note";

    if (isProgressNote) obj["descriptions"] = descriptions;

    if (isProgressNote && supportPlan === "yes")
      obj.fields["Description"] = descriptions
        ?.map((rest) => rest?.details?.outcomeTitle)
        ?.join(", ");

    if (edit) {
      let fields = { ...values };
      delete fields["noteId"];
      delete fields["noteType"];
      const obj = {
        ...values,
        id: data?.data?.id,
        fields,
        supportPlan,
        userId,
      };
      if (isProgressNote) obj["descriptions"] = descriptions;

      if (isProgressNote && supportPlan === "yes")
        obj.fields["Description"] = descriptions
          ?.map((rest) => rest?.details?.outcomeTitle)
          ?.join(", ");
      const validations = validateFields();
      if (validations !== true && supportPlan === "yes") {
        validateFields();
      } else {
        editNote(obj, false, resetForm);
        setErrors("");
      }
    } else {
      const validations = validateFields();
      if (validations !== true && supportPlan === "yes") {
        validateFields();
      } else {
        createNote(obj, resetForm);
        setErrors("");
      }
    }
  };

  function objectToString(obj) {
    let result = Object.entries(obj)
      .map(
        ([key, value]) =>
          `${key.charAt(0).toUpperCase() + key.slice(1)}: ${`"${
            value || "-"
          }"`}`
      )
      .join("\n");

    return result;
  }

  const arrayToString = (array) => {
    if (array?.length === 0 || array === undefined) return "";
    return array
      ?.filter((v) => v)
      ?.map((v, i) => `${i + 1}) ${v}`)
      .join("\n \n");
  };

  function filterNonNullFields(obj) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value !== null && value !== undefined && value !== "") {
        result[key] = value;
      }
    }
    return result;
  }

  const handlePatientChange = (patientId, name) => {
    setPatientsId(patientId);
    // setSelectedPatient(allPatients?.find((value) => value?.id === patientId));

    // auto populating facility related to this user...

    !edit && !view && setDescriptions([{ id: 1, ...initialDescription }]);

    form.setFieldValue(name, patientId);
    let facilityExists = noteType?.custom?.find(
      (value) => value?.fieldType?.name?.toLowerCase() === "facilities"
    );
    let patient = allPatients?.find((value) => value?.id === patientId);
    let pcpInfo = {
      "PCP Name": patient?.form2?.["pcpName"],
      "PCP Email": patient?.form2?.["pcpEmail"],
      "PCP Phone Number": patient?.form2?.["pcpPhoneNumber"],
      "PCP Fax Number": patient?.form2?.["pcpFaxNumber"],
    };

    let insuranceDetails = {
      "Insurance Company Name": patient?.form2?.["insuranceCompanyName"],
      "Member Name": patient?.form2?.["memberName"],
      "Member Number": patient?.form2?.["memberNumber"],
      "Prescription Group": patient?.form2?.["prescriptionGroup"],
      "Group Number": patient?.form2?.["groupNumber"],
      "Effective Date": formatDate(patient?.form2?.["effectiveDate"]),
    };
    // form.setFieldValue(facilityExists?.field, patient?.facilityId?.id);
    (edit || view) &&
      form.setFieldValue(
        facilityExists?.field,
        data?.data?.fields?.["Facility Name"]
      );

    form.setFieldValue("All PCP Info", objectToString(pcpInfo));
    form.setFieldValue(
      "Known Allergies",
      arrayToString(patient?.form1?.knownAllergies)
    );
    form.setFieldValue(
      "Dietary Restrictions",
      arrayToString(patient?.form1?.dietaries)
    );

    form.setFieldValue(
      "Known Illnes",
      arrayToString(
        patient?.form1?.knownIllness
          ? patient?.form1?.knownIllness?.map(
              (v) =>
                `${v?.illness || ""} - Contagious: "${v?.contagious || ""}"`
            )
          : []
      ) || "-"
    );
    form.setFieldValue("Insurance Details", objectToString(insuranceDetails));
    form.setFieldValue("Known Wounds", patient?.form1?.woundsInformation);

    form.setFieldValue("Medication Records", "");
    form.setFieldValue("Support Plan", "");
    setMedicationOptions(
      Array.isArray(patient?.form3)
        ? patient?.form3?.map((value) => {
            let { isPrescribed, id, ...rest } = value;
            return {
              label: value?.medicationName,
              value: objectToString({
                ...filterNonNullFields(rest),
                Prescribed: isPrescribed ? "Yes" : "No",
              }),
            };
          })
        : []
    );

    setSupportOptions(
      allPlans
        ?.find((v) => v?.client?.id === patient?.id)
        ?.outcomes?.map(({ id, ...rest }) => ({
          value: objectToString({
            ...filterNonNullFields(rest),
          }),
          label: rest.outcomeTitle,
        })) || []
    );
    if (patient) setSelectedPatient(patient);
  };

  const handleEssentialTypeChangeForNoteView = (value, frequency) => {
    const matchingSupport = allPlans
      ?.filter(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true
      )
      ?.flatMap((v) => v?.essentialSupport || [])
      ?.filter((_es) => _es?.essentialSupportType === value);
    const formattedFrequency = Array.from(
      new Set(
        matchingSupport
          .map((item) => item?.howOftenEssentialSupport)
          .filter(Boolean)
      )
    ).map((freq) => ({
      label: freq,
      value: freq,
    }));

    // setFrequencyOptions(
    //   formattedFrequency.length > 0 ? formattedFrequency : []
    // );

    // setEssentialSupport()

    const formattedEssentialNumber = Array.from(
      new Set(
        matchingSupport?.map((item) => item?.essentialNumber).filter(Boolean)
      )
    ).map((freq) => ({
      label: freq,
      value: freq,
    }));
    // setEssentialNumber(
    //   formattedEssentialNumber.length > 0 ? formattedEssentialNumber : []
    // );

    const matchingFrequency = allPlans
      ?.filter(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true
      )
      ?.flatMap((v) => v?.essentialSupport || [])
      ?.filter((_es) => _es?.howOftenEssentialSupport === frequency);

    const matchingSupportType = matchingFrequency?.filter(
      (_es) => _es?.essentialSupportType === value
    );
    // setActivities(matchingSupport?.map((item) => item?.activities).flat());
  };

  useEffect(() => {
    if (!opened) {
      setMedicationOptions([]);
      setSupportOptions([]);
      setDescriptions([{ id: 1, ...initialDescription }]);
      setSupportPlan("no");
      setEssentialSupportToggle("no");
      setDisplayAccordionTitle("");
      form.reset();
    }
    if (noteT && edit) {
      form?.setFieldValue(
        "noteType",
        allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id)?.name
      );

      let _noteType = {
        ...allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id),
      };
      let customs = _noteType ? [..._noteType?.custom] : [];
      let indexOfPatient = customs.findIndex(
        (v) => v?.field === noteType_Client
      );
      let patientClone = customs[indexOfPatient];
      if (indexOfPatient !== -1) {
        customs.splice(indexOfPatient, 1);
        customs.unshift(patientClone);
        _noteType.custom = customs;
      }
      setNoteType(_noteType);
      setSelectedFacility(data?.data?.fields?.["Facility Name"]);
    }
  }, [noteT, opened]);

  useEffect(() => {
    // if (edit) {
    //   if (data?.data?.fields)
    //     Object.entries(data?.data?.fields)?.map((value) => {
    //       if (
    //         `${value[1]}`.split(":")?.length === 3 &&
    //         `${value[1]}`.split("-")?.length === 3
    //       ) {
    //         let date = new Date(value[1]);
    //         form?.setFieldValue(value[0], date);
    //       } else {
    //         form?.setFieldValue(value[0], value[1]);
    //       }
    //     });
    // }

    if (edit) {
      const fields = data?.data?.fields;

      if (fields && typeof fields === "object" && !Array.isArray(fields)) {
        Object.entries(fields)?.map(([key, val]) => {
          if (
            `${val}`.split(":")?.length === 3 &&
            `${val}`.split("-")?.length === 3
          ) {
            const date = new Date(val);
            form?.setFieldValue(key, date);
          } else {
            form?.setFieldValue(key, val);
          }
        });
      } else {
      }
    }

    if (NOTETYPE && opened) {
      form?.setFieldValue(
        "noteType",
        allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE)?.name
      );

      let _noteType = {
        ...allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE),
      };
      let customs = _noteType ? [..._noteType?.custom] : [];
      let indexOfPatient = customs.findIndex(
        (v) => v?.field === noteType_Client
      );
      let patientClone = customs[indexOfPatient];
      if (indexOfPatient !== -1) {
        customs.splice(indexOfPatient, 1);
        customs.unshift(patientClone);
        _noteType.custom = customs;
      }
      setNoteType(_noteType);
    }
  }, [NOTETYPE, edit, opened]);

  useEffect(() => {
    if (opened && noteType?.name !== "Incident Report") {
      if (profile?.user?.type === "staff" && !view && !edit) {
        form.setFieldValue("Staff Name", profile?.user?.id);
      } else if (profile?.user?.type !== "staff" && !view && !edit) {
        form.setFieldValue("Staff Name", profile?.user?.id);
      } else {
        form.setFieldValue("Staff Name", data?.data?.fields["Staff Name"]);
      }
      // Facility is a single value on every note type (multi-client notes still
      // have exactly one facility) and the view/edit UI reads it from the form
      // field. The patient-match block below is skipped for multi-client notes
      // (Client Name is an array, so the single-id match fails), which left the
      // facility blank there — so populate it here for every note, up front.
      if (view || edit) {
        const facilityField = noteType?.custom?.find(
          (v) => v?.fieldType?.name?.toLowerCase() === "facilities"
        )?.field;
        if (facilityField && data?.data?.fields?.[facilityField] != null) {
          form.setFieldValue(facilityField, data?.data?.fields?.[facilityField]);
        }
      }
      let patientType = noteType?.custom?.find(
        (v) => v?.fieldType?.name === noteType_Client_Options
      );
      // Multi-select note types (e.g. Essential Support Note) store "Client
      // Name" as an ARRAY. The single-id comparisons below never match an
      // array, so `patient` stayed undefined and the entire patient-dependent
      // load block (medications, support options, AND essentialSupport/goals
      // with their toggles) was skipped — which is why saved essential
      // supports weren't showing in view even though they were in the DB.
      // Normalize an array value to its first client id before matching.
      const firstId = (v) => (Array.isArray(v) ? v?.[0] : v);
      const clientNameId = firstId(data?.data?.fields?.["Client Name"]);
      const patientFieldId = firstId(data?.data?.fields?.[patientType?.field]);
      // Same precedence the nested ternary here used to express (clientNameId >
      // "Patient Name" > the note type's own client field), minus the bug it
      // carried: the clientNameId branch was only reachable when the note ALSO
      // had a legacy "Patient Name". A Note Type Studio template has neither —
      // no "Patient Name", and its generated custom[] entries carry no
      // `fieldType` for `patientType` to match — so `patientFieldId` was
      // `fields[undefined]` and `patient` came back undefined, skipping the
      // block below that loads supportPlan / essentialSupportToggle and their
      // rows. That's why a template note's care-plan documentation was missing
      // from the view drawer even though it saved fine.
      const notePatientId =
        clientNameId || firstId(data?.data?.fields?.["Patient Name"]) || patientFieldId;
      let patient = allPatients?.find((value) => value?.id === notePatientId);
      if (patient) {
        form.setFieldValue(noteType_Client, patient.id);
        setMedicationOptions(
          Array.isArray(patient?.form3)
            ? patient?.form3?.map((value) => {
                let { isPrescribed, id, ...rest } = value;
                return {
                  label: value?.medicationName,
                  value: objectToString({
                    ...filterNonNullFields(rest),
                    Prescribed: isPrescribed ? "Yes" : "No",
                  }),
                };
              })
            : []
        );

        setSupportOptions(
          allPlans
            ?.find((v) => v?.client?.id === patient?.id)
            ?.outcomes?.map(({ id, ...rest }) => ({
              value: objectToString({
                ...filterNonNullFields(rest),
              }),
              label: rest.outcomeTitle,
            })) || []
        );
        setSelectedPatient(patient);
        setDescriptions(data?.data?.descriptions);

        setOutcomeNotes(data?.data?.descriptions?.map((_d) => _d?.description));
        setEssentialNotes(
          data?.data?.essentialSupport?.map((_e) => _e?.description)
        );
        setSupportPlan(data?.data?.supportPlan || "no");
        setEssentialSupportToggle(data?.data?.essentialSupportToggle || "no");
        setInterventionPlanToggle(data?.data?.interventionPlanToggle || "no");
        if (data?.data?.essentialSupport?.length) {
          setEssentialSupport(data?.data?.essentialSupport);
        }
        if (data?.data?.goals?.length) {
          setGoals(data?.data?.goals);
        }
      }
    }
    if (!view)
      noteType?.custom?.forEach((field) => {
        if (field?.fieldType?.name === "date" && !edit) {
          form?.setFieldValue(field.field, new Date());
        }
        if (field?.fieldType?.name === "time" && !edit) {
          const currentTime = new Date().toLocaleTimeString("en-US", {
            hour12: false,
          });
          const isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
          );
          if (isSafari) {
            let hours = new Date().getHours(),
              minutes = new Date().getMinutes();
            form?.setFieldValue(field.field, `${hours}:${minutes}`);
          } else {
            form?.setFieldValue(field.field, currentTime);
          }
        }
      });
  }, [noteType?.custom, opened]);

  useEffect(() => {
    if (opened && noteType?.name === "Incident Report") {
      // Incident Report stores arrays under the same field names every other
      // note type uses ("Client Name" / "Staff Name") — the generic useEffect
      // above skips this note type entirely, so the array values are never
      // pushed into the form, leaving the "Clients:"/"Staff:" render branches
      // with nothing to read. Older records (pre multi-client/staff) stored a
      // single id here instead of an array — wrap it so it still renders.
      const clientValue = data?.data?.fields?.["Client Name"];
      const staffValue = data?.data?.fields?.["Staff Name"];
      form.setFieldValue(
        "Client Name",
        Array.isArray(clientValue) ? clientValue : clientValue ? [clientValue] : []
      );
      form.setFieldValue(
        "Staff Name",
        Array.isArray(staffValue) ? staffValue : staffValue ? [staffValue] : []
      );
    }
  }, [opened, noteType?.name, data?.data]);

  useEffect(() => {
    if (userId) {
      handlePatientChange(userId, "Client Name");

      // setPatientsId(userId)
      // let patient = allPatients?.find((value) => value?.id === userId);
      // form.setFieldValue(noteType_Client, userId);
      // form.setFieldValue("Patient Name", userId);

      // let facilityExists = noteType?.custom?.find(
      //   (value) => value?.fieldType?.name?.toLowerCase() === "facilities"
      // );

      // form.setFieldValue(facilityExists?.field, patient?.facilityId?.id);
    }
  }, [userId, allPatients]);

  let getEssentialSupport = data?.data?.essentialSupport;

  // useEffect(() => {
  //   if (essentialSupport?.length > 0) {
  //     let data = getEssentialSupport?.[0];

  //     if (opened) {
  //       handleEssentialTypeChangeForNoteView(
  //         data?.essentialSupportType,
  //         data?.howOftenEssentialSupport
  //       );
  //     }

  //     // if (edit === true) {
  //     //   handleEssentialTypeChangeForNoteView(data?.essentialSupportType, data?.howOftenEssentialSupport);
  //     // } else if (view === true) {
  //     //   handleEssentialTypeChangeForNoteView(data?.essentialSupportType, data?.howOftenEssentialSupport);
  //     // }
  //   }
  // }, [opened, essentialSupport]);

  const initialValues = {};

  allNotesTypes?.ntypes?.custom?.map((value) => {
    initialValues[value?.field] = "";
  });

  const form = useForm({
    initialValues: (() => {
      const initialValues = { name: edit ? data?.data?.name : "" };
      // const initialValues = { name: edit ? data?.data?.name : profile?.user?.type === "staff" ? "" : profile?.user?.id };

      noteType?.custom?.forEach((field) => {
        initialValues[field.field] = "";
      });

      return initialValues;
    })(),
    validate: (values) => {
      const errors = {};
      noteType?.custom?.forEach((field) => {
        const fieldName = field.field;

        if (field.fieldType?.name === "number" && isNaN(values[fieldName])) {
          errors[fieldName] = "Must be a number";
        } else if (field.fieldType?.name === "number") {
          errors[fieldName] = null;
        }

        if (!values[fieldName]) {
          if (
            fieldName === "Description" &&
            noteType?.name === "Progress Note"
          ) {
          } else if (fieldName == "Shift") {
          } else {
            errors[fieldName] = "Required";
          }
        }
      });
      return errors;
    },
  });

  const [openedAccordion, setOpenedAccordion] = useState("0");

  const validateFields = () => {
    const newErrors = {};
    descriptions?.forEach((medication, index) => {
      if (!medication?.outcomeNumber) {
        newErrors[index] = "Field is required";
      }
      if (!medication?.outcomeTitle) {
        newErrors[index] = "Field is required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Mantine's DateInput requires value to be a real Date instance or null —
  // form fields loaded from raw API data (or the "" initial value) are
  // sometimes plain strings/empty strings, which crashes DateInput internals
  // with "value.toISOString is not a function". Coerce defensively here.
  const toSafeDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  };

  // Maps a "was this goal met" style value to the mockup's metchip color
  // variant (.metchip.ok/.warn/.dang/.gray).
  const getMetChipClass = (value) => {
    if (!value) return null;
    if (/^yes|^met/i.test(value)) return classes.vMetChipOk;
    if (/^no/i.test(value)) return classes.vMetChipDang;
    if (/progress/i.test(value)) return classes.vMetChipWarn;
    return classes.vMetChipGray;
  };

  // Goal start/end times are stored as 24h "HH:mm" strings (edit mode shows
  // them via TimeInput format="12"). View mode has no TimeInput, so format to
  // the same 12h display here; leave already-formatted/empty values untouched.
  const formatGoalTime = (t) => {
    if (!t) return "";
    const m = moment(t, ["HH:mm", "H:mm", "hh:mm A", "hh:mm a"], true);
    return m.isValid() ? m.format("hh:mm A") : t;
  };

  // Support Plan Outcomes, read-only: the mockup shows every outcome as a plain,
  // always-expanded stacked card, so view mode skips the Accordion entirely.
  //
  // Called from two places. ReturnFormItem's Description/"Support Plan" branch
  // covers Progress Notes and legacy types carrying a "Support Plan" custom
  // field — they reach it by iterating noteType.custom. A Note Type Studio
  // template renders through StudioSectionsForm and has no such custom field for
  // that branch to hook onto, so the drawer body calls this directly; otherwise
  // a template note's outcomes had no render path here at all and the view
  // drawer showed "Use care plan? Yes" with nothing under it.
  const outcomesViewCard = () => (
    <Box className={classes.vCard}>
      <Text className={classes.vCardHeading}>
        <IoMdCheckboxOutline /> Support Plan Outcomes
      </Text>
      {descriptions?.map((medication, index) => {
        const labels = planTypeLabels[medication?.planId];
        return (
          <Box key={medication?.id || index} className={classes.vAccItem}>
            <Box className={classes.vGoalHead}>
              <Text className={classes.vGoalTitle}>
                {medication?.details?.outcomeNumber
                  ? `Outcome ${medication.details.outcomeNumber} · ${medication?.details?.outcomeTitle || ""}`
                  : medication?.details?.outcomeTitle}
              </Text>
              {medication?.metGoal && (
                <Text
                  component="span"
                  className={`${classes.vMetChip} ${getMetChipClass(medication?.metGoal)}`}
                >
                  {medication?.metGoal}
                </Text>
              )}
            </Box>
            <Box className={classes.vPlanRef}>
              <Box className={classes.vRefLine}>
                <Text className={classes.vRefLineLabel}>
                  {labels?.outcomeCategoryLabel || "Category"}
                </Text>
                <Text className={classes.vRefLineVal}>
                  {medication?.outComeCategory}
                </Text>
              </Box>
            </Box>
            <Box className={classes.vDocSec} mt={12}>
              <Text className={classes.vDocLabel}>Progress note</Text>
              <Text className={classes.vDocBody}>{medication?.description}</Text>
            </Box>
          </Box>
        );
      })}
    </Box>
  );

  // outcome fields accordion
  const ReturnFormItem = (data, index, textArea = "") => {
    let { field: name, fieldType, placeholder, options, viewOnly } = data;

    if (
      textArea &&
      supportPlan === "no" &&
      essentialSupportToggle === "no" &&
      interventionPlanToggle === "no" &&
      data?.field === "Description" &&
      (noteType?.name === "Progress Note" ||
        noteType?.id === Essential_Support_Note)
    ) {
      return (
        <Box
          className={view ? classes.vCard : undefined}
          style={view ? undefined : { background: "var(--app-surface)", padding: "1rem", borderRadius: "10px" }}
        >
          {view ? (
            <Text className={classes.vCardHeading}>Note</Text>
          ) : (
            <Box className={classes.outcomeContianer}>
              <Text className={classes.outcomeText} mb={3}>
                Note
              </Text>
            </Box>
          )}
          <Textarea
            key={index}
            radius="md"
            maxRows={10}
            minRows={5}
            variant={view ? "unstyled" : undefined}
            placeholder={placeholder || "Enter text"}
            autosize={view || (viewOnly ? true : false) ? true : false}
            className={
              view
                ? classes.vDocField
                : `${classes.myfont} ${classes.descriptionText}`
            }
            {...form.getInputProps(name)}
            readOnly={view || (viewOnly ? true : false)}
            disable={view || (viewOnly ? true : false)}
          />
        </Box>
      );
    }
    if (
      supportPlan === "yes" &&
      (noteType?.name === "Progress Note" ||
        noteType?.custom?.find((_c) => _c?.field === "Support Plan")) &&
      (data?.field === "Description" || data?.field === "Support Plan") &&
      textArea
      // supportPlan === "yes" &&
      // (noteType?.name === "Progress Note" ||
      //   noteType?.custom?.find((_c) => _c?.field === "Support Plan")
      //   //  data?.field === "Support Plan"
      // ) &&
      // // (data?.field === "Description" || data?.field === "Support Plan")
      // textArea
      // // &&
      // // data?.field === "Support Plan"
    ) {
      if (view) return outcomesViewCard();
      return (
        <Box style={{ overflowY: "auto", maxHeight: "100%" }}>
          {/* <Box style={{ overflowY: "auto", height: "200px" }}> */}
          {/* <Radio.Group
            name="useSupportPlan"
            label="Use Support Plan"
            value={supportPlan}
            onChange={setSupportPlan}
            style={{ marginBottom: "10px" }}
          >
            <Group mt="xs">
              <Radio color="yellow" disabled={view} value="yes" label="Yes" />
              <Radio color="yellow" disabled={view} value="no" label="No" />
            </Group>
          </Radio.Group> */}
          {/* {supportPlan === "yes" && ( */}
          {
            // supportPlan === "yes" &&
            // (noteType?.name === "Progress Note" ||
            //   noteType?.custom?.find((_c) => _c?.field === "Support Plan"))
            //   &&
            <>
              <Accordion
                value={openedAccordion}
                onChange={setOpenedAccordion}
                chevron={<IconChevronDown size={34} color="var(--app-text)" />}
                chevronPosition="right"
                chevronSize={34}
                styles={{
                  chevron: {
                    transition: "transform 200ms ease",
                    "&[data-active]": {
                      transform: "rotate(180deg)",
                    },
                  },
                }}
              >
                {descriptions?.map((medication, index) => {
                  const labels = planTypeLabels[medication?.planId];
                  return (
                    <Accordion.Item
                      className={classes.accordionItem}
                      value={`${index}`}
                      style={{
                        marginBottom:
                          index === descriptions?.length - 1 ? "0" : "1rem",
                      }}
                    >
                      <Accordion.Control className={classes.accordionCon}>
                        {(medication?.outcomeNumber === "" ||
                          medication?.outcomeTitle === "") && (
                          <Box className={classes.accordionControl}>
                            <Text variant="text" fw={600}>
                              Outcome
                            </Text>
                            <Text
                              variant="text"
                              color="red"
                              onClick={() => removeMedication(medication.id)}
                            >
                              Delete
                            </Text>
                          </Box>
                        )}
                        {(typeof medication?.outcomeNumber === "number" ||
                          typeof medication?.outcomeTitle === "number") && (
                          <SimpleGrid
                            className={classes.staffContainer}
                            style={{
                              justifyContent:
                                openedAccordion === `${index}`
                                  ? "end"
                                  : "center",
                            }}
                          >
                            {openedAccordion !== `${index}` && (
                              <>
                                <Box
                                  className={classes.staffContainer}
                                  style={{ width: isMobileScreen ? "100%" : "250px" }}
                                >
                                  {/* <Badge color="yellow" size="xl" circle>
                                    {medication?.details?.outcomeNumber}
                                  </Badge> */}
                                  <Text
                                    variant="text"
                                    // className={classes.accordionTitle}
                                    sx={{
                                      minWidth: "150px",
                                      color: "var(--app-text-muted)",
                                    }}
                                  >
                                    {medication?.details?.outcomeTitle}
                                  </Text>
                                  <Text variant="text" fw={600}>
                                    {labels?.addNewButtonLabel || ""}{" "}
                                    {medication?.details?.outcomeNumber}
                                  </Text>
                                </Box>
                                {/* <Box
                                  className={classes.staffContainer}
                                  style={{ width: "250px" }}
                                >
                                  <Text variant="text" fw={600}>
                                    Title:
                                  </Text>
                                  <Text
                                    variant="text"
                                    className={classes.accordionTitle}
                                    sx={{ minWidth: "150px" }}
                                  >
                                    {medication?.details?.outcomeTitle}
                                  </Text>
                                </Box>
                                <Box
                                  className={classes.staffContainer}
                                  style={{
                                    width: "500px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Box className={classes.staffContainer}>
                                    <Text variant="text" fw={600}>
                                      {labels?.outcomeCategoryLabel || ""}
                                    </Text>
                                    <Text
                                      variant="text"
                                      className={classes.accordionTitle}
                                      sx={{ minWidth: "200px" }}
                                    >
                                      {medication?.details?.outcomeCategory}
                                    </Text>
                                  </Box>
                                </Box> */}
                              </>
                            )}

                            <Box className={classes.staffContainer}>
                              {!view && (
                                <Text
                                  variant="text"
                                  color="red"
                                  onClick={() =>
                                    removeMedication(medication.id)
                                  }
                                >
                                  Delete
                                </Text>
                              )}
                            </Box>
                          </SimpleGrid>
                        )}
                      </Accordion.Control>
                      <Accordion.Panel>
                        {/* <Group align="center">
                        <Text variant="text" fw={500} mb={15}>
                          Select an Outcome
                        </Text>
                      </Group> */}
                        <Text className={classes.vGoalTitle}>
                          {medication?.details?.outcomeTitle}
                        </Text>
                        <Divider mt={10} mb={15} />
                        <div key={medication.id}>
                          {view == true ||
                          (edit && !noteData?.data?.planActive === false) ? (
                            <Box className={classes.vPlanRef}>
                              <Box className={classes.vRefLine}>
                                <Text className={classes.vRefLineLabel}>
                                  {labels?.outcomeNumberLabel || "Outcome Number"}
                                </Text>
                                <Text className={classes.vRefLineVal}>
                                  {medication?.details?.outcomeNumber}
                                </Text>
                              </Box>
                              <Box className={classes.vRefLine}>
                                <Text className={classes.vRefLineLabel}>
                                  {labels?.outcomeCategoryLabel || "Category"}
                                </Text>
                                <Text className={classes.vRefLineVal}>
                                  {medication?.outComeCategory}
                                </Text>
                              </Box>
                              <Box className={classes.vRefLine}>
                                <Text className={classes.vRefLineLabel}>
                                  Was this goal met
                                </Text>
                                <Text className={classes.vRefLineVal}>
                                  {medication?.metGoal}
                                </Text>
                              </Box>
                            </Box>
                          ) : (
                            <Grid
                              gutter={10}
                              cols={isMobileScreen ? 1 : 3}
                              className={classes.mwd}
                              sx={{
                                paddingBottom: 30,
                              }}
                            >
                              <Grid.Col span={3} xs={12}>
                                <Select
                                  size="sm"
                                  required
                                  id="outcome-number"
                                  data={outcomeNumbers}
                                  label="Outcome Number"
                                  className={classes.selectBG}
                                  placeholder="Select Outcome Number"
                                  value={medication?.outcomeNumber}
                                  onChange={(value) => {
                                    handleMedicationChange(
                                      medication.id,
                                      "outcomeNumber",
                                      value
                                    );
                                  }}
                                  disabled={view}
                                  variant="filled"
                                  rightSectionPointerEvents="none"
                                  rightSection={icon}
                                />
                                {errors[index] && (
                                  <Text color="red" fz={14}>
                                    {errors[index]}
                                  </Text>
                                )}
                              </Grid.Col>
                              <Grid.Col span={5} xs={12}>
                                <Select
                                  required
                                  size="sm"
                                  data={outComeTitle}
                                  label="Outcome Title"
                                  className={classes.selectBG}
                                  placeholder="Select Outcome Title"
                                  value={medication?.outcomeTitle}
                                  onChange={(value) => {
                                    handleMedicationChange(
                                      medication.id,
                                      "outcomeTitle",
                                      value
                                    );
                                  }}
                                  disabled={view}
                                  variant="filled"
                                  rightSectionPointerEvents="none"
                                  rightSection={icon}
                                />
                                {errors[index] && (
                                  <Text color="red" fz={14}>
                                    {errors[index]}
                                  </Text>
                                )}
                              </Grid.Col>
                              <Grid.Col span={4} xs={12}>
                                <TextInput
                                  className={classes.myfont}
                                  label={
                                    <Text className={classes.infoLabel}>
                                      Outcome Category
                                    </Text>
                                  }
                                  size="sm"
                                  placeholder="Enter outcome category"
                                  value={medication?.outComeCategory}
                                  disabled
                                />
                              </Grid.Col>
                            </Grid>
                          )}
                          {/* info accordion */}
                          <ViewInfo data={medication} />
                          <Box className={classes.vDocSec} mt={12}>
                            <Text className={classes.vDocLabel}>Progress note</Text>
                            <Text className={classes.vDocBody}>
                              {medication?.description}
                            </Text>
                          </Box>
                          {/* <Box className={classes.textInputBox}>
                          <Text className="label">Add Note //</Text>
                          <Textarea
                            id="add-note"
                            className={`${classes.myfont} ${classes.descriptionText}`}
                            size="sm"
                            maxRows={5}
                            minRows={10}
                            placeholder="Enter Note"
                            value={medication?.description}
                            onChange={(e) => {
                              handleMedicationChange(
                                medication.id,
                                "description",
                                e?.target?.value
                              );
                            }}
                            readOnly={view}
                            autosize={view}
                          />
                        </Box> */}
                          {!view && (
                            <p style={{ color: "red", margin: 0, padding: 0 }}>
                              {medication?.error}
                            </p>
                          )}

                          {/* <Divider my="sm" variant="dashed" /> */}
                        </div>
                        {/* <Select
                        id="about-goal"
                        size="sm"
                        data={[
                          "Yes",
                          "No",
                          "Goal in progress",
                          "Not Applicable",
                        ]}
                        label="Was this goal met?"
                        placeholder="Select a response"
                        value={medication?.metGoal}
                        onChange={(value) => {
                          handleMedicationChange(
                            medication.id,
                            "metGoal",
                            value
                          );
                        }}
                        disabled={view}
                        variant="filled"
                        rightSection={icon}
                        className={classes.select}
                        rightSectionPointerEvents="none"
                      /> */}
                      </Accordion.Panel>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
              {/* {!view && (
                <Button
                  size="sm"
                  m={10}
                  color="yellow"
                  onClick={addDescription}
                  style={{ marginLeft: "auto", display: "block" }}
                >
                  Add New Outcome
                </Button>
              )} */}
            </>
          }
        </Box>
      );
    }
    // field object
    let obj = {
      string: view ? (
        <Box>
          <Text className={classes.vLabel}>{name}</Text>
          <Text className={classes.vVal}>
            {form?.getInputProps(name)?.value || "-"}
          </Text>
        </Box>
      ) : (
        <TextInput
          size="xs"
          id="reason"
          key={index}
          type="text"
          label={name}
          variant="unstyled"
          {...form.getInputProps(name)}
          disabled={viewOnly ? true : false}
          placeholder={placeholder || `Enter response`}
        />
      ),
      "text area":
        view ? (
          <Box className={classes.vCard}>
            <Text className={classes.vCardHeading}>
              {data?.field === "Description"
                ? noteType?.name === "Incident Report"
                  ? "What Happened"
                  : "Note"
                : name}
            </Text>
            <Text className={classes.vDocBody}>
              {form?.getInputProps(name)?.value || "—"}
            </Text>
          </Box>
        ) : (
          <Box className={view || viewOnly ? classes.vDocSec : classes.outcomeContianer}>
            <Text
              htmlFor={name}
              className={view || viewOnly ? classes.vDocLabel : classes.outcomeText}
            >
              {name}
            </Text>

            <Textarea
              id={
                data?.field === "Description"
                  ? "enter-description"
                  : data?.field === "Medication"
                  ? "enter-medication"
                  : "enter-note"
              }
              key={index}
              variant={view || viewOnly ? "unstyled" : undefined}
              minRows={view || (viewOnly ? true : false) ? 5 : 10}
              maxRows={view || (viewOnly ? true : false) ? 5 : 10}
              autosize={view || (viewOnly ? true : false) ? true : false}
              placeholder={placeholder || `Enter response`}
              className={
                view || viewOnly
                  ? classes.vDocField
                  : `${classes.myfont} ${classes.descriptionText}`
              }
              style={view || viewOnly ? undefined : { height: "500px !important" }}
              {...form.getInputProps(name)}
              readOnly={view || viewOnly ? true : false}
            />
          </Box>
        ),

      number: (
        <Flex direction={"column"}>
          {view ? (
            <TextInput
              readOnly
              key={index}
              type="number"
              variant="unstyled"
              {...form.getInputProps(name)}
              className={classes.timeDateView}
              label={name}
            />
          ) : (
            <TextInput
              size="xs"
              key={index}
              label={name}
              type="number"
              variant="filled"
              className={classes.selectBG}
              {...form.getInputProps(name)}
              disabled={view || (viewOnly ? true : false) || !serviceNumber}
              placeholder={placeholder || `Enter response`}
            />
          )}
          {isBilling_Services && (
            <Text fz={12} fs="italic" c={"#ccc"}>
              Approved Units: {serviceNumber?.servicenumber}
            </Text>
          )}
        </Flex>
      ),

      time: (
        <Box>
          {view ? (
            <TimeInput
              readOnly={view}
              key={index}
              ref={ref}
              variant="unstyled"
              placeholder={`Select ${name}`}
              className={classes.timeDateView}
              {...form.getInputProps(name)}
              label={name}
            />
          ) : (
            <TimeInput
              label={name}
              variant="unstyled"
              key={index}
              ref={ref}
              size="xs"
              placeholder={`Select ${name}`}
              className={classes.myfont}
              rightSection={
                <ActionIcon onClick={() => ref?.current?.showPicker()}>
                  <IconClock size="1rem" stroke={1.5} />
                </ActionIcon>
              }
              {...form.getInputProps(name)}
              onChange={(e) => {
                const isSafari = /^((?!chrome|android).)*safari/i.test(
                  navigator.userAgent
                );
                const datetime = new Date(e?.target?.value).toLocaleTimeString(
                  "en-US",
                  { hour12: false }
                );
                let time = e.target.value?.split(":")?.slice(0, 2)?.join(":");
                isSafari
                  ? form.setFieldValue(name, time)
                  : form.setFieldValue(name, e?.target?.value);
              }}
              disabled={view || (viewOnly ? true : false)}
              style={{ borderBottom: "2px solid #aaaaaa" }}
            />
          )}
        </Box>
      ),
      date: (
        <Box>
          {view ? (
            <DateInput
              size="md"
              readOnly
              key={index}
              id="date-click"
              variant="unstyled"
              className={classes.timeDateView}
              {...form.getInputProps(name)}
              value={toSafeDate(form.getInputProps(name)?.value)}
              placeholder={`Select ${name}`}
              label={name}
            />
          ) : (
            <DateInput
              size="xs"
              key={index}
              label={name}
              id="date-click"
              variant="unstyled"
              className={classes.myfont}
              {...form.getInputProps(name)}
              value={toSafeDate(form.getInputProps(name)?.value)}
              placeholder={`Select ${name}`}
              disabled={view || (viewOnly ? true : false)}
              style={{ borderBottom: "2px solid #aaaaaa" }}
              rightSection={
                <img
                  style={{ width: "30px" }}
                  src={"/assets/images/calendar-icon.png"}
                  alt="Icon"
                />
              }
            />
          )}
        </Box>
      ),
      Clients: Array.isArray(form?.getInputProps(name)?.value) ? (
        <Box>
          <Text className={classes.vLabel}>{name}</Text>
          <Text className={classes.vVal}>
            {(() => {
              const clientOptions = getOptions(noteType_Client_Options, noteType?.custom);
              const names = form
                .getInputProps(name)
                ?.value?.map((id) => clientOptions?.find((option) => option.value === id)?.label)
                .filter(Boolean);
              return names?.length > 0 ? names.join(", ") : "None";
            })()}
          </Text>
        </Box>
      ) : (
        <Select
          size="xs"
          searchable
          label={name}
          variant="filled"
          rightSection={icon}
          defaultValue={userId}
          id={"client-name-note"}
          className={classes.selectBG}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          required={viewOnly || userId ? false : true}
          onChange={(v) => handlePatientChange(v, name)}
          data={getOptions(noteType_Client_Options, noteType?.custom)}
          disabled={view || edit || (viewOnly || userId ? true : false)}
        />
      ),
      Provider: view ? (
        <Box>
          <Text className={classes.vLabel}>{name}</Text>
          <Text className={classes.vVal}>
            {selectedPatient?.providerId?.[0]?.name || "-"}
          </Text>
        </Box>
      ) : (
        <Select
          size="xs"
          searchable
          label={name}
          variant="filled"
          rightSection={icon}
          // defaultValue={userId}
          id={"client-name-note"}
          className={classes.selectBG}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          // required={viewOnly || userId ? false : true}
          onChange={(v) => handlePatientChange(v, name)}
          value={selectedPatient?.providerId?.[0]?.id || ""}
          data={
            selectedPatient?.providerId?.length > 0
              ? selectedPatient?.providerId?.map((_p) => ({
                  value: _p?.id,
                  label: _p?.name,
                }))
              : []
          }
          disabled={true}
        />
      ),

      Facilities: view ? (
        <Select
          readOnly
          size="md"
          searchable
          variant="unstyled"
          {...form.getInputProps(name)}
          className={classes.timeDateView}
          // View is read-only, so show the full facility list (unfiltered).
          // The per-client filter used at create time yields an empty option
          // set on multi-client notes (selectedPatient isn't set), which left
          // the saved facility with no matching option and rendered blank.
          data={getOptions("Facilities", noteType?.custom)}
          label={name}
        />
      ) : (
        <Select
          size="xs"
          searchable
          label={name}
          variant="filled"
          rightSection={icon}
          className={classes.selectBG}
          {...form.getInputProps(name)}
          placeholder={`Select ${name} XX`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          required={viewOnly || userId ? false : true}
          // data={getOptions("Facilities", noteType?.custom)}
          data={
            noteType?.name === "Incident Report"
              ? getOptions("Facilities", noteType?.custom)
              : getOptions("Facilities", noteType?.custom)?.filter((opt) => {
                  if (Array.isArray(selectedPatient?.facilityId)) {
                    if (
                      selectedPatient?.facilityId?.find(
                        (fac) => fac?.id == opt?.value
                      )
                    ) {
                      return opt;
                    }
                  } else {
                    if (selectedPatient?.facilityId?.id == opt?.value) {
                      return opt;
                    }
                  }
                })
          }
          // selectedPatient
        />
      ),
      Staff: view ? (
        <Box>
          <Text className={classes.vLabel}>{name}</Text>
          <Text className={classes.vVal}>
            {(() => {
              const fieldValue = form?.getInputProps(name)?.value;
              const staffOptions = getOptions("Staff", noteType?.custom);
              if (Array.isArray(fieldValue)) {
                const names = fieldValue
                  .map((id) => staffOptions?.find((option) => option.value === id)?.label)
                  .filter(Boolean);
                return names.length > 0 ? names.join(", ") : "-";
              }
              return (
                staffOptions?.find((option) => option.value === fieldValue)?.label || "-"
              );
            })()}
          </Text>
        </Box>
      ) : (
        <Box className={classes.staffField}>
          <Text ff={"Inter"} fz={12} fw={500} color="var(--app-text-muted)">
            {name}
          </Text>
          <Select
            w={isMobileScreen ? "100%" : 250}
            size="md"
            variant="filled"
            rightSectionPointerEvents="none"
            data={getOptions("Staff", noteType?.custom)}
            placeholder={`Select ${name}`}
            searchable
            defaultValue={form?.getInputProps(name)}
            className={classes.myfont}
            {...form.getInputProps(name)}
            disabled={
              viewOnly
                ? true
                : !edit && profile?.user?.type === "staff"
                ? true
                : false
            }
          />
        </Box>
      ),
      "Facility Types": view ? (
        <Select
          readOnly
          size="md"
          searchable
          variant="unstyled"
          {...form.getInputProps(name)}
          className={classes.timeDateView}
          data={getOptions("Facility Types", noteType?.custom)}
          label={name}
        />
      ) : (
        <Select
          size="xs"
          searchable
          label={name}
          variant="filled"
          rightSection={icon}
          className={classes.myfont}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("Facility Types", noteType?.custom)}
        />
      ),
      Other: (
        <Box>
          {view ? (
            <Select
              readOnly
              size="md"
              searchable
              id="enter-shift"
              variant="unstyled"
              {...form.getInputProps(name)}
              className={classes.timeDateView}
              placeholder={"None"}
              data={getOptions("Other", noteType?.custom, name)}
              label={name}
              required={data?.field?.toLowerCase() == "shift" ? false : true}
              // rightSection={icon}
              // rightSectionPointerEvents="none"
              // disabled={view || (viewOnly ? true : false)}
            />
          ) : (
            <Select
              size="xs"
              required={data?.field?.toLowerCase() == "shift" ? false : true}
              searchable
              label={name}
              id="enter-shift"
              variant="filled"
              rightSection={icon}
              className={classes.selectBG}
              {...form.getInputProps(name)}
              placeholder={`Select ${name}`}
              rightSectionPointerEvents="none"
              disabled={view || (viewOnly ? true : false)}
              data={getOptions("Other", noteType?.custom, name)}
            />
          )}
        </Box>
      ),
      "Multiple Choice": view ? (
        <Box>
          <Text className={classes.vLabel}>{name}</Text>
          <Text className={classes.vVal}>
            {(() => {
              const selected = form.getInputProps(name)?.value;
              const opts = getOptions("multiple choices", noteType?.custom, name);
              const selectedValues = Array.isArray(selected)
                ? selected
                : selected
                ? [selected]
                : [];
              const labels = selectedValues
                .map((v) => opts?.find((o) => o?.value === v)?.label)
                .filter(Boolean);
              return labels.length ? labels.join(", ") : "-";
            })()}
          </Text>
        </Box>
      ) : (
        <Checkbox.Group
          label={name}
          id="enter-shift"
          required={data?.field?.toLowerCase() === "shift" ? false : true}
          {...form.getInputProps(name)}
        >
          {getOptions("multiple choices", noteType?.custom, name)?.map(
            (option) => (
              <Checkbox
                color="gray"
                key={option?.value}
                value={option?.value}
                label={option?.label}
                disabled={view || (viewOnly ? true : false)}
                mt={index === 0 ? "10px" : "10px"}
              />
            )
          )}
        </Checkbox.Group>
      ),
      "Single Choice": view ? (
        <Box>
          <Text className={classes.vLabel}>{name}</Text>
          <Text className={classes.vVal}>
            {getOptions("single choice", noteType?.custom, name)?.find(
              (o) => o?.value === form.getInputProps(name)?.value
            )?.label || "-"}
          </Text>
        </Box>
      ) : (
        <Radio.Group
          label={name}
          id="enter-shift"
          required={data?.field?.toLowerCase() === "shift" ? false : true}
          {...form.getInputProps(name)}
        >
          {getOptions("single choice", noteType?.custom, name)?.map(
            (option) => (
              <Radio
                disabled={view || (viewOnly ? true : false)}
                color="gray"
                key={option?.value}
                value={option?.value}
                label={option?.label}
                mt={index === 0 ? "10px" : "10px"}
              />
            )
          )}
        </Radio.Group>
      ),
      Dropdown: view ? (
        <Select
          readOnly
          size="md"
          searchable
          variant="unstyled"
          id="enter-shift"
          {...form.getInputProps(name)}
          className={classes.timeDateView}
          placeholder={"None"}
          data={getOptions("dropdown", noteType?.custom, name)}
          label={name}
        />
      ) : (
        <Select
          size="md"
          radius="md"
          required={data?.field?.toLowerCase() == "shift" ? false : true}
          searchable
          className={classes.select}
          label={name}
          id="enter-shift"
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("dropdown", noteType?.custom, name)}
        />
      ),
      "Medication Records": view ? (
        <Box>
          <Text className={classes.vLabel}>{name}</Text>
          <Text className={classes.vVal}>
            {(Array.isArray(medicationOptions) ? medicationOptions : [])?.find(
              (o) => o?.value === form?.getInputProps(name)?.value
            )?.label || "-"}
          </Text>
        </Box>
      ) : (
        <Group align="flex-end">
          <Select
            size="xs"
            searchable
            label={name}
            data={medicationOptions}
            className={classes.myfont}
            {...form.getInputProps(name)}
            placeholder={`Select ${name}`}
            disabled={viewOnly ? true : false}
            icon={<img src="/assets/images/home2.png" alt="home" />}
          />
          <Popover
            shadow="md"
            width={300}
            position="bottom-end"
            style={{ marginBottom: "10px" }}
          >
            <Popover.Target>
              <IconInfoCircle
                color="gray"
                styles={{ marginTop: "30px !important" }}
              />
            </Popover.Target>
            <Popover.Dropdown sx={{ pointerEvents: "none" }}>
              <Textarea
                key={`${index}-test`}
                radius="md"
                autosize={true}
                icon={
                  <img
                    className={classes.descriptionIcon}
                    src="/assets/images/home2.png"
                    alt="home"
                  />
                }
                placeholder={
                  placeholder || `Select ${name} to see details here.`
                }
                className={`${classes.myfont} ${classes.descriptionText}`}
                style={{ height: "200px !important", marginTop: "10px" }}
                value={form.values[name]}
                disabled={true}
              />
            </Popover.Dropdown>
          </Popover>
        </Group>
      ),
      "level of need": view ? (
        <Box>
          <Text className={classes.vLabel}>{name}</Text>
          <Text className={classes.vVal}>
            {getOptions("level of need", noteType?.custom)?.find(
              (o) => o?.value === form?.getInputProps(name)?.value
            )?.label || "-"}
          </Text>
        </Box>
      ) : (
        <Select
          size="md"
          radius="md"
          searchable
          className={classes.select}
          label={name}
          id="enter-shift"
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={viewOnly ? true : false}
          data={getOptions("level of need", noteType?.custom)}
        />
      ),
      // "Support Plan": (
      //   <Group align="flex-end">
      //     <Select
      //       size="xs"
      //       searchable
      //       label={name}
      //       data={supportOptions}
      //       className={classes.myfont}
      //       {...form.getInputProps(name)}
      //       placeholder={`Select ${name}`}
      //       disabled={view || (viewOnly ? true : false)}
      //       icon={<img src="/assets/images/home2.png" alt="home" />}
      //     />
      //     <Popover
      //       width={300}
      //       shadow="md"
      //       position="bottom-end"
      //       style={{ marginBottom: "10px" }}
      //     >
      //       <Popover.Target>
      //         <IconInfoCircle
      //           color="gray"
      //           styles={{ marginTop: "30px !important" }}
      //         />
      //       </Popover.Target>
      //       <Popover.Dropdown sx={{ pointerEvents: "none" }}>
      //         <Textarea
      //           key={`${index}-test`}
      //           radius="md"
      //           autosize={true}
      //           icon={
      //             <img
      //               className={classes.descriptionIcon}
      //               src="/assets/images/home2.png"
      //               alt="home"
      //             />
      //           }
      //           placeholder={
      //             placeholder || `Select ${name} to see details here.`
      //           }
      //           className={`${classes.myfont} ${classes.descriptionText}`}
      //           // style={{ height: "200px !important", marginTop: "10px" }}
      //           style={{ height: "200px !important", marginTop: "10px" }}
      //           value={form.values[name]}
      //           disabled={true}
      //         />
      //       </Popover.Dropdown>
      //     </Popover>
      //   </Group>
      // ),
    };
    if (
      (essentialSupportToggle === "yes" || interventionPlanToggle === "yes") &&
      name === "Description" &&
      textArea
    )
      return null;
    else if (!textArea && fieldType?.name != "text area") {
      return obj[fieldType?.name];
    } else if (textArea && fieldType?.name === "text area")
      return obj[fieldType?.name];
    else return null;
  };

  //    const [matchedActivity, setMatchedActivity] = useState(null);

  //    useEffect(() => {
  //   if (view === true && data?.data?.essentialSupport?.length > 0) {
  //     const getEssentialSupport = data?.data?.essentialSupport;

  //     const matchedActivities = getEssentialSupport.map((es) =>
  //       es?.activities?.find(
  //         (activity) => activity?.id === es?.essentialActivityNumber
  //       )
  //     );

  //     setMatchedActivity(matchedActivities);

  //     // If you're storing combined support + activities in a new state
  //     setEssentialSupport({
  //       ...getEssentialSupport,
  //       activities: matchedActivities,
  //     });
  //   }
  // }, [view, data?.data?.essentialSupport]);

  // useEffect(() => {
  //   if (essentialSupport && essentialSupport.length > 0 && view === true) {
  //     const getEssentialSupport = data?.data?.essentialSupport;

  //     const matchedActivities = getEssentialSupport?.map((es) =>
  //       es?.activities?.find(
  //         (activity) => activity?.id === es?.essentialActivityNumber
  //       )
  //     );

  //     setMatchedActivity(matchedActivities);
  //     // setEssentialSupport(matchedActivities);
  //         setEssentialSupport((prev) =>
  //         {...prev,
  //           activities: matchedActivities,
  //         }
  //       );
  //   }
  // }, [essentialSupport, view]);

  // useEffect(() => {
  //   if (essentialSupport && essentialSupport.length > 0 && view === true) {
  //     const getEssentialSupport = data?.data?.essentialSupport;

  //     ;const matchedActivity = getEssentialSupport?.map((es) => es?.activities.find(
  //       (activity) => activity.id === getEssentialSupport?.essentialActivityNumber
  //     ));

  //     setMatchedActivity(matchedActivity);

  //     // if (matchedActivity) {

  //     //   // example: use matchedActivity data
  //     //   handleEssentialTypeChangeForNoteView(
  //     //     data.essentialSupportType,
  //     //     data.howOftenEssentialSupport,
  //     //     matchedActivity
  //     //   );
  //     // }
  //   }
  // }, [essentialSupport, view])

  const showRadioButtons =
    (noteType?.name === "Incident Report" &&
      noteType?.name === "Medication Note") ||
    noteType?.name === "Progress Note" ||
    noteType?.custom?.find((_c) => _c?.field === "Support Plan");

  const isEssentialSupportNote = noteType?.id === Essential_Support_Note;
  const isInterventionProgressNote =
    noteType?.id === Intervention_Progress_Note;
  const hasSupportPlan = noteType?.custom?.some(
    (_c) => _c?.field === "Support Plan"
  );

  const handleToggleChange = (e) => {
    setEssentialSupportToggle(e);
  };

  const handleReject = async () => {
    if (!noteRejectValue) {
      // Set an error message to be displayed on the screen
      setReasonError("Reason field is required");
      return;
    }

    try {
      const rejectionData = {
        noteId: noteData?.data?.id,
        approvalStatus: "rejected",
        rejectionReason: noteRejectValue,
        rejectionDescriptions: noteRejectionDescp,
      };
      const response = await updateNoteStatus(rejectionData);
      if (response?.status === 200) {
        setShowRejectedNote(false);
        setShowRejection(false);
        setShowApproved(false);
        setNoteRejectValue(null);
        setNoteRejectionDescp(null);
        getTodaysNotes("");
        // getPendingNotes();
        getPendingActions()
        onApprovalChanged?.();
        close();
      }
    } catch (error) {}
  };

  // Approve-button click: for Incident Reports, block the optimistic
  // "approved" flip (setShowApproved) when the signature pad is empty —
  // isEmpty() is synchronous so we validate WITHOUT triggering the S3 upload
  // resolve() would do. Without this guard, setShowApproved(true) hid the
  // Approve/Reject buttons before handleApprove could return, stranding the
  // user with the error and no way to retry.
  const handleApproveClick = () => {
    if (isIncidentReport && incidentSignatureRef.current?.isEmpty?.()) {
      setSignatureError("Signature is required to approve an Incident Report.");
      return;
    }
    setSignatureError("");
    setShowApproved(true);
    setShowRejectedNote(false);
    handleApprove();
  };

  const handleApprove = async () => {
    try {
      // Incident Reports go through editNote instead of updateNoteStatus: it
      // records who signed off (kept beside the incident data as an audit
      // trail) and refreshes the notes list, so the row badge flips to
      // "Approved" straight away.
      if (isIncidentReport) {
        const base = noteData?.data?.incidentDetails || {};
        const signedBy = profile?.user?.name || profile?.admin?.name || "";
        const now = new Date().toISOString();

        // An Incident Report cannot be approved without the supervisor's
        // signature — resolve() returns null when nothing was drawn/typed/
        // uploaded, so block approval and surface the inline error instead of
        // silently approving unsigned.
        const captured = await incidentSignatureRef.current?.resolve();
        if (!captured) {
          setSignatureError(
            "Signature is required to approve an Incident Report."
          );
          // Roll back the optimistic flip so the Approve/Reject buttons
          // reappear and the user can sign and retry.
          setShowApproved(false);
          return;
        }
        setSignatureError("");

        const result = await editNote(
          {
            id: noteData?.data?.id,
            approvalStatus: "approved",
            incidentDetails: {
              ...base,
              reviewedBy: profile?.admin?.name || profile?.user?.name || "",
              reviewedAt: now,
              reporterName: signedBy,
              reporterSignature: captured.signatureText,
              reporterSignatureImage: captured.signatureImage,
              reporterSignedAt: now,
            },
          },
          true,
          null,
          undefined,
          undefined,
          () => {},
          undefined,
          undefined,
          undefined
        );
        if (result) {
          getTodaysNotes("");
          getPendingActions();
          onApprovalChanged?.();
          close();
          setShowApproved(false);
        }
        return;
      }

      const approvedData = {
        noteId: noteData?.data?.id,
        approvalStatus: "approved",
      };
      const response = await updateNoteStatus(approvedData);
      if (response?.status === 200) {
        getTodaysNotes("");
        // getPendingNotes();
        getPendingActions()
        onApprovalChanged?.();
        close();
        setShowApproved(false);
      }
    } catch (error) {}
  };

  // Same condition the Approve/Reject buttons have always used — computed
  // once so it can be reused both inside the view-mode sticky footer and by
  // the pre-existing standalone box (kept for the edit-mode case, where the
  // sticky footer doesn't apply), without changing when the buttons appear.
  const canApproveOrReject =
    !showRejection &&
    !showApproved &&
    showApprovalControls &&
    (!profile?.user?.type || profile?.user?.role == "admin") &&
    noteData?.data?.approvalStatus !== "approved" &&
    noteData?.data?.approvalStatus !== "rejected";

  const isPendingBadgeVisible = noteData?.data?.approvalStatus === "pending";

  // Whether a note IS approved/rejected is a fact about the note, independent
  // of whether THIS screen also lets the viewer click Approve/Reject
  // (showApprovalControls) — that gate belongs on canApproveOrReject (the
  // buttons) only, not on whether we show the "Approved/Rejected by" info.
  const isRejectedBadgeVisible =
    showRejectedNote || noteData?.data?.approvalStatus === "rejected";

  const isApprovedBadgeVisible =
    showApproved || noteData?.data?.approvalStatus === "approved";

  // Client-card content, computed once so it can be dropped into its own
  // separate card in view mode (mockup's vclientcard) while still nesting
  // inside the single combined card edit mode has always used — same JSX,
  // just wrapped differently depending on mode.
  const clientCardNode =
    noteType?.name === "Incident Report" ||
    Array.isArray(data?.data?.fields?.["Client Name"]) ? (
      (() => {
        // Group Note is NOT multi-client here — the backend splits a
        // multi-client submission into one separate Note per client at
        // create time, so every Group Note document always has a single
        // "Client Name" (the multi-select only exists in the create UI).
        // It falls through to the single-client branch below like any
        // other note type.
        const clientValue = data?.data?.fields?.["Client Name"];
        const clientIds = Array.isArray(clientValue)
          ? clientValue
          : clientValue
          ? [clientValue]
          : [];
        const clients = clientIds
          .map((id) => allPatients?.find((p) => p?.id === id))
          .filter(Boolean);
        if (!clients.length) return null;
        // Show every client as its own avatar + name laid out horizontally
        // (wrapping to new rows as needed), so a multi-client note reads all
        // participants at a glance instead of a "First +N" summary.
        return (
          <Flex wrap="wrap" gap="md" align="center">
            {clients.map((c, i) => (
              <Box key={c?.id || i} className={classes.vClientCard}>
                <Avatar
                  size={46}
                  radius={46}
                  shape="circle"
                  className={classes.vAvatar}
                  src={
                    c?.imageurl
                      ? decrypt(c.imageurl)
                      : "/assets/images/personal2.png"
                  }
                />
                <Box>
                  <Text className={classes.vClientLabel}>Client</Text>
                  <Text className={classes.vClientName}>{c?.name}</Text>
                </Box>
              </Box>
            ))}
          </Flex>
        );
      })()
    ) : (
      (view || selectedPatient || edit || patientsId) && (
        <Box className={classes.vClientCard}>
          <Avatar
            size={46}
            radius={46}
            shape="circle"
            className={classes.vAvatar}
            src={
              selectedPatient?.imageurl
                ? decrypt(selectedPatient?.imageurl)
                : "/assets/images/personal2.png"
            }
          />
          <Box>
            <Text className={classes.vClientLabel}>Client</Text>
            <Text className={classes.vClientName}>{selectedPatient?.name}</Text>
          </Box>
        </Box>
      )
    );

  // Meta-fields grid content, computed once so it can be dropped into its
  // own separate card in view mode (mockup's viewgrid) while still nesting
  // inside the single combined card edit mode has always used.
  const fieldsGridNode = (
    <>
      <SimpleGrid
        className={view ? undefined : classes.mwd}
        cols={isMobileScreen ? 1 : view ? 2 : 4}
        spacing={view ? 20 : undefined}
      >
        {noteType?.custom?.map((value, index) =>
          value.field !== "Staff Name" &&
          value.field !== "Client Name" &&
          value.field !== "Level of Need"
            ? ReturnFormItem(value, index)
            : null
        )}
        {isInterventionProgressNote ? (
          // Intervention Progress Note Display
          <Box className={classes.supportPlan}>
            {view ? (
              <>
                <Text className={classes.vLabel}>Intervention Plan</Text>
                <Text className={classes.vVal} tt={"capitalize"}>
                  {interventionPlanToggle}
                </Text>
              </>
            ) : (
              <Radio.Group
                size="xs"
                value={interventionPlanToggle}
                name="useInterventionPlan"
                label="Use Intervention Plan"
                onChange={setInterventionPlanToggle}
                style={{ marginBottom: "10px" }}
              >
                <Group mt="xs">
                  <Radio value="yes" label="Yes" color="yellow" disabled={view} />
                  <Radio value="no" label="No" color="yellow" disabled={view} />
                </Group>
              </Radio.Group>
            )}
          </Box>
        ) : isEssentialSupportNote ? (
          // Essential Support Note Display
          <Box className={classes.supportPlan}>
            {view ? (
              <>
                <Text className={classes.vLabel}>Essential Support Plan</Text>
                <Text className={classes.vVal} tt={"capitalize"}>
                  {essentialSupportToggle}
                </Text>
              </>
            ) : (
              // Add your Essential Support Note input/edit component here
              <Radio.Group
                size="xs"
                value={essentialSupportToggle}
                name="useSupportPlan"
                label="Use Essential Support"
                onChange={handleToggleChange}
                style={{ marginBottom: "10px" }}
              >
                <Group mt="xs">
                  <Radio value="yes" label="Yes" id="check-yes" color="yellow" disabled={view} />
                  <Radio value="no" label="No" color="yellow" disabled={view} />
                </Group>
              </Radio.Group>
            )}
          </Box>
        ) : // Original Support Plan Radio/View
        view ? (
          <Box className={classes.supportPlan}>
            {showRadioButtons && (
              <>
                <Text className={classes.vLabel}>Support Plan</Text>
                <Text className={classes.vVal} tt={"capitalize"}>
                  {supportPlan}
                </Text>
              </>
            )}
          </Box>
        ) : (
          <Radio.Group
            size="xs"
            value={supportPlan}
            name="useSupportPlan"
            label="Support Plan"
            onChange={setSupportPlan}
            style={{ marginBottom: "10px" }}
          >
            <Group mt="xs">
              <Radio value="yes" label="Yes" id="check-yes" color="yellow" disabled={view} />
              <Radio value="no" label="No" color="yellow" disabled={view} />
            </Group>
          </Radio.Group>
        )}
      </SimpleGrid>
      {isBilling_Services && (
        <SimpleGrid cols={isMobileScreen ? 1 : 4} mt={10}>
          {view ? (
            <Box>
              <Text className={classes.vLabel}>Service (Unit Type: Days)</Text>
              <Text className={classes.vVal}>
                {selectedPatient?.form1?.services?.find(
                  (val) => val?.servicenumber === form.getInputProps("Service Type")?.value
                )?.servicetitle || "-"}
              </Text>
            </Box>
          ) : (
            <Select
              size="xs"
              searchable
              label={"Service (Unit Type: Days)"}
              variant="filled"
              rightSection={icon}
              id={"client-name-note"}
              className={classes.selectBG}
              {...form.getInputProps("Service Type")}
              placeholder={`Select Service (Unit Type: Days)`}
              rightSectionPointerEvents="none"
              required={view || userId ? false : true}
              onChange={(v) => {
                handlePatientChange(v, "Service Type");
              }}
              data={
                selectedPatient
                  ? selectedPatient?.form1?.services?.map((val) => ({
                      value: val?.servicenumber,
                      label: val?.servicetitle,
                    }))
                  : []
              }
              disabled={view}
            />
          )}
        </SimpleGrid>
      )}
    </>
  );

  const noteTypeRequiresApproval = () => {
    if (isIncidentReport) return true;
    const orgAdminId = noteData?.data?.admin?._id || noteData?.data?.admin;
    const override = noteType?.adminApprovals?.find(
      (a) => String(a?.admin?._id || a?.admin) === String(orgAdminId)
    );
    if (override) return !!override.status;
    return noteType?.approvalRequired === true;
  };
  const creatorId =
    noteData?.data?.createdBy?._id ||
    noteData?.data?.createdBy?.id ||
    noteData?.data?.createdBy;
  const creatorIsAdmin =
    noteData?.data?.createdBy?.type?.toLowerCase() !== "staff" ||
    noteData?.data?.createdBy?.role?.toLowerCase() === "admin";
  const viewerIsCreator = String(profile?.user?.id) === String(creatorId);
  const hideStatusCard =
    noteData?.data?.approvalStatus === "approved" &&
    (!noteTypeRequiresApproval() ||
      (!isIncidentReport && creatorIsAdmin && viewerIsCreator));

  return (
    <>
      {/* <div style={{ overflowX: "auto" }}>
        <div style={{ minWidth: "1000px" }}> */}
      <Drawer
        position="right"
        radius={isMobileScreen ? 0 : 16}
        offset={isMobileScreen ? 0 : 10}
        shadow="md"
        size={isMobileScreen ? "100%" : 800}
        zIndex={2100}
        opened={opened}
        overlayProps={{ blur: 1 }}
        className={classes.noteViewNewDrawer}
        scrollAreaComponent={ScrollArea}
        withCloseButton={false}
        onClose={() => {
          resetForm();
          setNoteRejectValue(null);
          setNoteRejectionDescp("");
          setOpenedAccordion("0");
          setView(false);
        }}
      >
        <Group position="apart" p="13px 19px" className={classes.viewDrawerHeader}>
          <Text className={classes.viewDrawerTitle}>
            <span>{view ? "View" : edit ? "Edit" : "Add New"}</span>{" "}
            <span>{noteType?.name}</span>
          </Text>
          <Button variant="unstyled" onClick={close} p="0px" className={classes.viewDrawerClose}>
            <RxCross1 size={20} />
          </Button>
        </Group>

        <form
          onSubmit={form?.onSubmit((values) => onSave(values))}
          style={{
            background: "var(--app-bg)",
            padding: isMobileScreen ? "8px 12px" : "8px 24px",
            height: "100%",
            // overflow: "scroll",
          }}
        >
          {view && noteData?.data?.id && !hideStatusCard && (
            <Box className={classes.vCard}>
              <Box className={classes.vTop}>
                <Text className={classes.vId}>
                  #{`${noteData?.data?.id}`.slice(-6).toUpperCase()}
                </Text>
                <Box
                  component="span"
                  className={`${classes.vPill} ${
                    noteData?.data?.approvalStatus === "approved"
                      ? classes.vPillOk
                      : noteData?.data?.approvalStatus === "rejected"
                      ? classes.vPillDang
                      : classes.vPillWarn
                  }`}
                >
                  <span className="dot" />
                  {noteData?.data?.approvalStatus === "approved"
                    ? "Approved"
                    : noteData?.data?.approvalStatus === "rejected"
                    ? "Rejected"
                    : noteData?.data?.approvalStatus === "draft"
                    ? "Draft"
                    : "Pending"}
                </Box>
              </Box>
              {(() => {
                // An approved/rejected note has an actual review action to
                // report; a pending note instead reports who submitted it and
                // when, mirroring the design mockup's "Awaiting approval /
                // Submitted <date>" row.
                if (
                  !isApprovedBadgeVisible &&
                  !isRejectedBadgeVisible &&
                  !isPendingBadgeVisible
                ) {
                  return null;
                }
                const actorProfile = isApprovedBadgeVisible
                  ? noteData?.data?.approvedBy
                  : isRejectedBadgeVisible
                  ? noteData?.data?.rejectedBy
                  : noteData?.data?.createdBy;
                const actionDate = isApprovedBadgeVisible
                  ? noteData?.data?.approvedAt
                  : isRejectedBadgeVisible
                  ? noteData?.data?.rejectedAt
                  : noteData?.data?.createdAt;
                // Notes approved/rejected before approvedBy/rejectedBy existed
                // have no actor/date saved — skip this row entirely for them
                // too, rather than showing a blank/placeholder name and date.
                if (!actorProfile && !actionDate) {
                  return null;
                }
                // Profile fields (like signatures elsewhere in this file) are
                // AES-encrypted — decrypt name client-side; photo is a plain
                // URL so it needs no decryption.
                const actorName = actorProfile?.name
                  ? decrypt(actorProfile.name) || actorProfile.name
                  : null;
                const actorPhoto = actorProfile?.photo;
                const apprDate = formatDate(actionDate);
                const apprTime = formatTime(actionDate);
                const apprTxt = isApprovedBadgeVisible
                  ? "Note approved"
                  : isRejectedBadgeVisible
                  ? "Note rejected"
                  : "Awaiting approval";
                const apprSub = isApprovedBadgeVisible
                  ? `Approved by ${actorName || "—"} · ${apprDate || ""} ${apprTime || ""}`
                  : isRejectedBadgeVisible
                  ? `Rejected by ${actorName || "—"} · ${apprDate || ""}`
                  : `Submitted ${apprDate || ""}`;
                const initials = actorName
                  ? actorName
                      .trim()
                      .split(/\s+/)
                      .map((w) => w[0])
                      .slice(0, 2)
                      .join("")
                      .toUpperCase()
                  : "—";
                return (
                  <Box className={classes.vAppr}>
                    {actorPhoto ? (
                      <img
                        src={actorPhoto}
                        alt={actorName || "avatar"}
                        className={classes.vApprAvatar}
                      />
                    ) : (
                      <Box component="span" className={classes.vApprAvatar}>
                        {initials}
                      </Box>
                    )}
                    <Box style={{ flex: 1 }}>
                      <Text className={classes.vApprText}>{apprTxt}</Text>
                      <Text className={classes.vApprSub}>{apprSub}</Text>
                    </Box>
                  </Box>
                );
              })()}
              {isRejectedBadgeVisible && (
                <Box className={classes.vReason}>
                  <Text ff={"Inter"} fz={12} fw={400} color="var(--app-text-muted)">
                    Reason
                  </Text>
                  <Text ff={"Inter"} fz={14} fw={500} color="var(--app-text)">
                    {noteData?.data?.rejectionReason || "-"}
                  </Text>
                  <Text ff={"Inter"} fz={12} fw={400} color="var(--app-text-muted)" mt={6}>
                    Description
                  </Text>
                  <Text ff={"Inter"} fz={14} fw={500} color="var(--app-text)">
                    {noteData?.data?.rejectionDescriptions || "-"}
                  </Text>
                </Box>
              )}
            </Box>
          )}

          {!view && (
            <SimpleGrid cols={1}>
              {noteType?.custom?.map((value, index) => {
                if (value.field !== "Staff Name") return null;
                return (
                  <React.Fragment key={index}>
                    {ReturnFormItem(value, index)}
                  </React.Fragment>
                );
              })}
            </SimpleGrid>
          )}

          {view ? (
            <>
              {clientCardNode && (
                <Box className={classes.vCard}>{clientCardNode}</Box>
              )}
              {/* A studio template renders all its fields from `sections` via
                  StudioSectionsForm below — its `custom` list is empty, so
                  fieldsGridNode is blank and would show as an empty card. */}
              {!isStudioTemplate && (
                <Box className={classes.vCard}>{fieldsGridNode}</Box>
              )}
            </>
          ) : (
            <Box
              className={classes.modalContentBG}
              sx={{
                padding: "1rem",
                background: "var(--app-surface)",
                border: "1px solid #E5E5EA",
              }}
            >
              <Box className={classes.modalTopHeader}>{clientCardNode}</Box>
              <Divider my="md" />
              <Box className={classes.bottomFields}>{fieldsGridNode}</Box>
            </Box>
          )}

          {!view && <Divider my="md" />}
            {isStudioTemplate && (
              <StudioSectionsForm
                sections={noteType?.sections}
                form={form}
                classes={classes}
                view={true}
              />
            )}
            {!view && (
            <Box className={classes.bottomFields}>
              <SimpleGrid className={classes.mwd} cols={isMobileScreen ? 1 : 4}>
                {!isStudioTemplate &&
                  noteType?.custom?.map((value, index) =>
                    value.field !== "Staff Name" &&
                    value.field !== "Client Name" &&
                    value.field !== "Level of Need"
                      ? ReturnFormItem(value, index)
                      : null
                  )}
                {isInterventionProgressNote ? (
                  // Intervention Progress Note Display
                  <Box className={classes.supportPlan}>
                    {view ? (
                      <>
                        <Text
                          ff={"Inter"}
                          fz={12}
                          fw={400}
                          ta="start"
                          color="var(--app-text-muted)"
                          w={180}
                        >
                          Intervention Plan
                        </Text>
                        <Text
                          ff={"Inter"}
                          color="var(--app-text)"
                          fz={14}
                          ta="start"
                          fw={600}
                          tt={"capitalize"}
                        >
                          {interventionPlanToggle}
                        </Text>
                      </>
                    ) : (
                      <Radio.Group
                        size="xs"
                        value={interventionPlanToggle}
                        name="useInterventionPlan"
                        label="Use Intervention Plan"
                        onChange={setInterventionPlanToggle}
                        style={{ marginBottom: "10px" }}
                      >
                        <Group mt="xs">
                          <Radio
                            value="yes"
                            label="Yes"
                            color="yellow"
                            disabled={view}
                          />
                          <Radio
                            value="no"
                            label="No"
                            color="yellow"
                            disabled={view}
                          />
                        </Group>
                      </Radio.Group>
                    )}
                  </Box>
                ) : isEssentialSupportNote ? (
                  // Essential Support Note Display
                  <Box className={classes.supportPlan}>
                    {view ? (
                      <>
                        <Text
                          ff={"Inter"}
                          fz={12}
                          fw={400}
                          ta="start"
                          color="var(--app-text-muted)"
                          w={180}
                        >
                          Essential Support Plan
                        </Text>
                        <Text
                          ff={"Inter"}
                          color="var(--app-text)"
                          fz={14}
                          ta="start"
                          fw={600}
                          tt={"capitalize"}
                        >
                          {essentialSupportToggle}
                        </Text>
                      </>
                    ) : (
                      // Add your Essential Support Note input/edit component here
                      <Radio.Group
                        size="xs"
                        value={essentialSupportToggle}
                        name="useSupportPlan"
                        label="Use Essential Support"
                        onChange={handleToggleChange}
                        style={{ marginBottom: "10px" }}
                      >
                        <Group mt="xs">
                          <Radio
                            value="yes"
                            label="Yes"
                            id="check-yes"
                            color="yellow"
                            disabled={view}
                          />
                          <Radio
                            value="no"
                            label="No"
                            color="yellow"
                            disabled={view}
                          />
                        </Group>
                      </Radio.Group>
                    )}
                  </Box>
                ) : // Original Support Plan Radio/View
                view ? (
                  <Box className={classes.supportPlan}>
                    {hasSupportPlan && (
                      <>
                        <Text ff={"Inter"} fz={16} fw={500} color="var(--app-text-muted)">
                          Support Plan
                        </Text>
                        <Text ff={"Inter"} fz={16} fw={600} tt={"capitalize"}>
                          {supportPlan}
                        </Text>
                      </>
                    )}
                  </Box>
                ) : (
                  <Radio.Group
                    size="xs"
                    value={supportPlan}
                    name="useSupportPlan"
                    label="Support Plan"
                    onChange={setSupportPlan}
                    style={{ marginBottom: "10px" }}
                  >
                    <Group mt="xs">
                      <Radio
                        value="yes"
                        label="Yes"
                        id="check-yes"
                        color="yellow"
                        disabled={view}
                      />
                      <Radio
                        value="no"
                        label="No"
                        color="yellow"
                        disabled={view}
                      />
                    </Group>
                  </Radio.Group>
                )}
              </SimpleGrid>
              {isBilling_Services && (
                <SimpleGrid cols={isMobileScreen ? 1 : 4} mt={10}>
                  <Select
                    size="xs"
                    searchable
                    label={"Service (Unit Type: Days)"}
                    variant="filled"
                    rightSection={icon}
                    // defaultValue={userId}
                    id={"client-name-note"}
                    className={classes.selectBG}
                    {...form.getInputProps("Service Type")}
                    placeholder={`Select Service (Unit Type: Days)`}
                    rightSectionPointerEvents="none"
                    required={view || userId ? false : true}
                    onChange={(v) => {
                      handlePatientChange(v, "Service Type");
                    }}
                    data={
                      selectedPatient
                        ? selectedPatient?.form1?.services?.map((val) => ({
                            value: val?.servicenumber,
                            label: val?.servicetitle,
                          }))
                        : []
                    }
                    disabled={view}
                  />
                </SimpleGrid>
              )}
            </Box>
            )}
          {/* </Box> */}
          {!isStudioTemplate && !view && (
          <Text pt={"24px"} ff={"Inter"} fz={14} fw={500} color="var(--app-text)">
            Details
          </Text>
          )}

          {!isStudioTemplate && (
          <Box
            className={classes.modalContentBG}
            style={{
              overflowY:
                noteType?.name !== "Progress Note" ? "auto" : "visible",
              maxHeight: noteType?.name !== "Progress Note" ? "100%" : "auto",
              height: noteType?.name !== "Progress Note" ? "100%" : "auto",
              marginTop: "0.5rem",
            }}
          >
            {/* -----> Level of need <----- */}
            {noteType?.custom?.filter(
              (value) => value?.field === "Level of Need"
            ) &&
              noteType?.custom
                ?.filter((value) => value.field === "Level of Need")
                .map((value, index) => (
                  <Box mb={10}>{ReturnFormItem(value, index)}</Box>
                ))}

            <SimpleGrid cols={1} className={classes.mwd}>
              {!isStudioTemplate &&
                noteType?.custom?.map((value, index) =>
                  ReturnFormItem(value, index, "text area")
                )}
            </SimpleGrid>
          </Box>
          )}

          {noteType?.name === "Incident Report" &&
            (() => {
              const f = data?.data?.fields || {};
              const d = data?.data?.incidentDetails || {};
              const clientIds = Array.isArray(f["Client Name"])
                ? f["Client Name"]
                : f["Client Name"]
                ? [f["Client Name"]]
                : [];
              const staffIds = Array.isArray(f["Staff Name"])
                ? f["Staff Name"]
                : f["Staff Name"]
                ? [f["Staff Name"]]
                : [];
              const Field = ({ label, value }) => (
                <Box mb={12}>
                  <Text className={classes.vLabel}>{label}</Text>
                  <Text className={classes.vVal}>{value || "—"}</Text>
                </Box>
              );

              return (
                <>
                  {/* Incident Classification */}
                  <Box className={classes.detailsForm} mt={16}>
                    <Text className={classes.incidentClassificationTitle}>
                      <LuBookOpen />
                      INCIDENT CLASSIFICATION
                    </Text>
                    <Grid>
                      <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Field
                          label="Incident Type"
                          value={
                            d.incidentType === "Other" && d.otherType
                              ? `Other — ${d.otherType}`
                              : d.incidentType
                          }
                        />
                      </Grid.Col>
                      <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Field label="Severity" value={d.severity} />
                      </Grid.Col>
                    </Grid>
                  </Box>

                  {/* Injuries & Medical Attention */}
                  <Box className={classes.detailsForm} mt={16}>
                    <Text className={classes.incidentClassificationTitle}>
                      <LuPlus />
                      INJURIES &amp; MEDICAL ATTENTION
                    </Text>
                    <Field
                      label="Was an injury sustained?"
                      value={d.injurySustained ? "Yes" : "No"}
                    />
                    {d.injurySustained && typeof d.injurySustained === "object" && (
                      <Grid>
                        <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Field
                            label="Description of Injury"
                            value={d.injurySustained.description}
                          />
                        </Grid.Col>
                        <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Field
                            label="Body Location"
                            value={d.injurySustained.bodyLocation}
                          />
                        </Grid.Col>
                        <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Field
                            label="Medical Attention"
                            value={d.injurySustained.medicalAttention}
                          />
                        </Grid.Col>
                      </Grid>
                    )}

                    <Box className={classes.incidentDivider} component="hr" />

                    <Field
                      label="Were emergency services (911 / EMS) called?"
                      value={d.emergencyServicesCalled ? "Yes" : "No"}
                    />
                    {d.emergencyServicesCalled &&
                      typeof d.emergencyServicesCalled === "object" && (
                        <Box className={classes.incidentSubSection}>
                          <Grid>
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              <Field
                                label="Was the client transported to the hospital?"
                                value={
                                  d.emergencyServicesCalled.clientTransported
                                    ? "Yes"
                                    : "No"
                                }
                              />
                            </Grid.Col>
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              <Field
                                label="Time EMS Arrived"
                                value={d.emergencyServicesCalled.timeEmsArrived}
                              />
                            </Grid.Col>
                            {d.emergencyServicesCalled.clientTransported && (
                              <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Field
                                  label="Receiving Hospital / Facility"
                                  value={d.emergencyServicesCalled.receivingHospital}
                                />
                              </Grid.Col>
                            )}
                          </Grid>
                        </Box>
                      )}
                  </Box>

                  {/* Restraint / Physical Intervention */}
                  <Box className={classes.detailsForm} mt={16}>
                    <Text className={classes.incidentClassificationTitle}>
                      <LuPower />
                      RESTRAINT / PHYSICAL INTERVENTION
                    </Text>
                    <Field
                      label="Was a restraint or physical intervention used?"
                      value={d.restraintUsed ? "Yes" : "No"}
                    />
                    {d.restraintUsed && typeof d.restraintUsed === "object" && (
                      <Grid>
                        <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Field
                            label="Type of Intervention"
                            value={d.restraintUsed.type}
                          />
                        </Grid.Col>
                        <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Field
                            label="Duration (minutes)"
                            value={d.restraintUsed.duration}
                          />
                        </Grid.Col>
                      </Grid>
                    )}
                  </Box>

                  {/* Notifications Made */}
                  {(() => {
                    const selectedClientPatients = clientIds
                      .map((id) => allPatients?.find((p) => p?.id === id))
                      .filter(Boolean);

                    const buildGroups = (patient) => {
                      const clientName = patient?.name || "";
                      // The client form only stores ONE guardian/emergency
                      // contact (guardianFirstName + guardianLastName ->
                      // emergencyContactName) — there is no separate
                      // "guardianFullName" field.
                      const guardianName = `${patient?.form2?.["guardianFirstName"] || ""} ${
                        patient?.form2?.["guardianLastName"] || ""
                      }`.trim();
                      const guardians = [];
                      if (guardianName) {
                        guardians.push({
                          key: `${patient?.id}-guardian`,
                          name: guardianName,
                          sub: [clientName, "Guardian"].filter(Boolean).join(" · "),
                          phone: patient?.form2?.["emergencyContactPhoneNumber"] || "",
                        });
                      }
                      const medicalProviders = [];
                      if (patient?.form2?.["pcpName"]) {
                        medicalProviders.push({
                          key: `${patient?.id}-pcp`,
                          name: patient.form2["pcpName"],
                          sub: [clientName, "Primary Physician"].filter(Boolean).join(" · "),
                          phone: patient?.form2?.["pcpPhoneNumber"] || "",
                        });
                      }
                      (patient?.form2?.["additionalProvider"] || []).forEach((prov, i) => {
                        if (prov?.providerName) {
                          medicalProviders.push({
                            key: `${patient?.id}-additional-${i}`,
                            name: prov.providerName,
                            sub: [clientName, prov?.providerType || "Provider"].filter(Boolean).join(" · "),
                            phone: prov?.providerPhone || "",
                          });
                        }
                      });
                      return { guardians, medicalProviders };
                    };

                    const groupDefs = [
                      { key: "guardians", label: "GUARDIANS & LEGAL REPRESENTATIVES" },
                      { key: "medicalProviders", label: "MEDICAL PROVIDERS" },
                      { key: "agencyInternal", label: "AGENCY & INTERNAL" },
                    ];

                    const allEntries = {
                      guardians: [],
                      medicalProviders: [],
                      agencyInternal: [],
                    };
                    selectedClientPatients.forEach((patient) => {
                      const groups = buildGroups(patient);
                      allEntries.guardians.push(...groups.guardians);
                      allEntries.medicalProviders.push(...groups.medicalProviders);
                    });

                    // Agency & internal contacts are org-level, not tied to a
                    // specific client. The Supervisor / Program Manager is the
                    // main admin on the account, so their name is shown here.
                    const supervisorName = profile?.admin?.name || "";
                    allEntries.agencyInternal = [
                      {
                        key: "agency-supervisor",
                        name: "Supervisor / Program Manager",
                        sub: supervisorName || "Main Admin",
                        phone: "On-call",
                      },
                      {
                        key: "agency-state-reporting",
                        name: "Agency / State Reporting Line",
                        sub: "Reportable-incident hotline",
                        phone: "",
                      },
                    ];

                    return (
                      <Box className={classes.detailsForm} mt={16}>
                        <Text className={classes.incidentClassificationTitle}>
                          <LuBell />
                          NOTIFICATIONS MADE
                        </Text>
                        {groupDefs.map((group) => {
                          const entries = allEntries[group.key];
                          if (entries.length === 0) return null;
                          const notifiedCount = entries.filter(
                            (e) => d.notifiedContacts?.[e.key]
                          ).length;
                          return (
                            <Box key={group.key} mb={12}>
                              <Text fz={12} fw={600} c="var(--app-text-muted)" mb={6}>
                                {group.label} ({notifiedCount} of {entries.length} notified)
                              </Text>
                              {entries.map((entry) => (
                                <Flex
                                  key={entry.key}
                                  align="center"
                                  gap={10}
                                  py={6}
                                  style={{ borderBottom: "1px solid var(--app-border)" }}
                                >
                                  <Checkbox
                                    checked={!!d.notifiedContacts?.[entry.key]}
                                    readOnly
                                    disabled
                                  />
                                  <Box>
                                    <Text fz={14} fw={600} c="var(--app-text)">
                                      {entry.name}
                                    </Text>
                                    <Text fz={12} c="var(--app-text-muted)">
                                      {[entry.sub, entry.phone].filter(Boolean).join(" · ")}
                                    </Text>
                                  </Box>
                                </Flex>
                              ))}
                            </Box>
                          );
                        })}
                        <Field
                          label="Notification Notes"
                          value={d.notificationNotes}
                        />
                      </Box>
                    );
                  })()}

                  {/* Follow-up & Preventive Action */}
                  <Box className={classes.detailsForm} mt={16}>
                    <Text className={classes.incidentClassificationTitle}>
                      <LuFileText />
                      FOLLOW-UP &amp; PREVENTIVE ACTION
                    </Text>
                    <Text fz={16} c="var(--app-text)">
                      {d.followUpAction || "—"}
                    </Text>
                  </Box>

                  {/* Signatures & Review */}
                  {(() => {
                    // The approval status itself is shown once, in the banner at
                    // the bottom of the drawer — this section only carries the
                    // signature, so it isn't repeated here.
                    const status = data?.data?.approvalStatus || "pending";
                    const isApproved = status === "approved";
                    const isRejected = status === "rejected";
                    const isSigned = !!d.reporterSignedAt;
                    return (
                      <Box className={classes.detailsForm} mt={16} mb={16}>
                        <Text className={classes.incidentClassificationTitle}>
                          <LuPenLine />
                          SIGNATURES &amp; REVIEW
                        </Text>

                        <Text fz={12} fw={500} c="var(--app-text-muted)">
                          Supervisor Signature
                        </Text>
                        {isSigned ? (
                          <Box
                            style={{
                              padding: "12px 16px",
                              backgroundColor: "#FFFFFF",
                              borderRadius: 8,
                              border: "1px solid var(--app-border)",
                              marginTop: 6,
                              marginBottom: 12,
                            }}
                          >
                            {d.reporterSignatureImage ? (
                              <img
                                src={decrypt(d.reporterSignatureImage)}
                                alt="Signature"
                                style={{ maxHeight: 60, objectFit: "contain" }}
                              />
                            ) : (
                              <Text
                                ff="Island Moments"
                                fz={28}
                                fw={400}
                                color="#171717"
                                style={{ lineHeight: 1.2 }}
                              >
                                {d.reporterSignature || d.reporterName || "—"}
                              </Text>
                            )}
                            <Text fz={12} c="var(--app-text-muted)">
                              Signed by {d.reporterName || "supervisor"} ·{" "}
                              {moment(d.reporterSignedAt).format(
                                "MMM D, YYYY · h:mm A"
                              )}
                            </Text>
                          </Box>
                        ) : isSupervisorAdmin && !isApproved && !isRejected ? (
                          <Box mt={6} mb={12}>
                            <SignaturePadField ref={incidentSignatureRef} />
                            {signatureError && (
                              <Text fz={12} c="red" mt={6}>
                                {signatureError}
                              </Text>
                            )}
                          </Box>
                        ) : (
                          <Text fz={16} fw={600} c="var(--app-text)" mb={12}>
                            Not signed
                          </Text>
                        )}
                      </Box>
                    );
                  })()}

                </>
              );
            })()}

          {!view && supportPlan === "yes" && (
            <Button
              m={10}
              size="sm"
              radius={8}
              color="yellow"
              onClick={addDescription}
              style={{
                marginLeft: "auto",
                display: "block",
              }}
            >
              <Text c="var(--app-on-primary)">Add New Outcome</Text>
            </Button>
          )}

          {/* A studio template's outcomes, which ReturnFormItem can't reach (see
              outcomesViewCard). Restricted to templates so a Progress Note — which
              does render through ReturnFormItem — doesn't print the card twice.
              The Essential Support block below needs no such branch: it already
              sits here at the drawer level rather than inside ReturnFormItem. */}
          {view &&
            isStudioTemplate &&
            supportPlan === "yes" &&
            descriptions?.length > 0 &&
            outcomesViewCard()}

          {essentialSupportToggle === "yes" &&
            (view ? (
              // Mockup lists each essential support entry as a plain,
              // always-expanded card — no collapse/expand.
              <Box className={classes.vCard}>
                <Text className={classes.vCardHeading}>
                  <IoMdCheckboxOutline /> Essential Support
                </Text>
                {Array.isArray(essentialSupport) &&
                  essentialSupport?.map((support, index) => {
                    const activityStatement = support?.activities
                      ?.filter(
                        (_a) => _a?.id === support?.essentialActivityNumber
                      )
                      ?.map((a) => a?.supportStatement)[0];
                    return (
                    <Box key={support?.id} className={classes.vAccItem}>
                      <Box className={classes.vGoalHead}>
                        <Text className={classes.vGoalTitle}>
                          Essential Support {support?.essentialNumber || index + 1}
                          {activityStatement ? ` · ${activityStatement}` : ""}
                        </Text>
                      </Box>
                      <Box className={classes.vPlanRef}>
                        <Box className={classes.vRefLine}>
                          <Text className={classes.vRefLineLabel}>
                            Essential Support Type
                          </Text>
                          <Text className={classes.vRefLineVal}>
                            {support?.essentialSupportType || "-"}
                          </Text>
                        </Box>
                        <Box className={classes.vRefLine}>
                          <Text className={classes.vRefLineLabel}>Frequency</Text>
                          <Text className={classes.vRefLineVal}>
                            {support?.howOftenEssentialSupport || "-"}
                          </Text>
                        </Box>
                        <Box className={classes.vRefLine}>
                          <Text className={classes.vRefLineLabel}>Outcome #</Text>
                          <Text className={classes.vRefLineVal}>
                            {support?.essentialNumber || index + 1}
                          </Text>
                        </Box>
                      </Box>
                      <Box className={classes.vDocSec} mt={12}>
                        <Text className={classes.vDocLabel}>Support provided</Text>
                        <Text className={classes.vDocBody}>
                          {support?.description?.length > 0
                            ? support?.description
                            : essentialNotes[index]}
                        </Text>
                      </Box>
                    </Box>
                    );
                  })}
              </Box>
            ) : (
              <Box style={{ overflowY: "auto", maxHeight: "100%" }}>
                <Accordion
                  value={essentialAccordion}
                  onChange={setEssentialAccordion}
                  mx={10}
                  variant="separated"
                  chevron={<IconChevronDown size={34} color="gray" />}
                  chevronPosition="right"
                  chevronSize={34}
                  styles={{
                    chevron: {
                      transition: "transform 200ms ease",
                      "&[data-active]": {
                        transform: "rotate(180deg)",
                      },
                    },
                  }}
                >
                  {Array.isArray(essentialSupport) &&
                    essentialSupport?.map((support, index) => (
                      <Accordion.Item
                        key={support?.id}
                        value={String(index)}
                        className={classes.accordionItem}
                      >
                        <Accordion.Control>
                          <Box className={classes.accordionControl}>
                            <Text>
                              Essential Support #
                              {support?.essentialNumber || index + 1}
                            </Text>
                            {!view && (
                              <Text
                                variant="text"
                                color="red"
                                onClick={() =>
                                  removeEssentialSupport(support?.id)
                                }
                              >
                                Delete
                              </Text>
                            )}
                          </Box>
                        </Accordion.Control>

                        <Accordion.Panel>
                          <Box className={classes.vPlanRef}>
                            <Box className={classes.vRefLine}>
                              <Text className={classes.vRefLineLabel}>
                                Essential Support Type
                              </Text>
                              <Text className={classes.vRefLineVal}>
                                {support?.essentialSupportType || "-"}
                              </Text>
                            </Box>
                            <Box className={classes.vRefLine}>
                              <Text className={classes.vRefLineLabel}>Frequency</Text>
                              <Text className={classes.vRefLineVal}>
                                {support?.howOftenEssentialSupport || "-"}
                              </Text>
                            </Box>
                            <Box className={classes.vRefLine}>
                              <Text className={classes.vRefLineLabel}>Outcome #</Text>
                              <Text className={classes.vRefLineVal}>
                                {support?.essentialNumber || index + 1}
                              </Text>
                            </Box>
                            <Box className={classes.vRefLine}>
                              <Text className={classes.vRefLineLabel}>
                                Essential Support Activities
                              </Text>
                              <Text className={classes.vRefLineVal}>
                                {support?.activities
                                  ?.filter(
                                    (_a) =>
                                      _a?.id === support?.essentialActivityNumber
                                  )
                                  ?.map((a) => a?.supportStatement)[0] || "-"}
                              </Text>
                            </Box>
                          </Box>
                          <EssentialViewInfo data={support} />
                          <Box className={classes.vDocSec} mt={12}>
                            <Text className={classes.vDocLabel}>Support provided</Text>
                            <Text className={classes.vDocBody}>
                              {support?.description?.length > 0
                                ? support?.description
                                : essentialNotes[index]}
                            </Text>
                          </Box>
                        </Accordion.Panel>
                      </Accordion.Item>
                    ))}
                </Accordion>
              </Box>
            ))}

          {!view && essentialSupportToggle === "yes" && (
            <Button
              m={10}
              size="sm"
              radius={8}
              color="yellow"
              onClick={addEssentialSupport}
              className={`${classes.responsiveBtn}`}
              style={{
                marginLeft: "auto",
                display: "block",
                marginTop: "10px",
              }}
            >
              <Text c="var(--app-on-primary)">Add New Support Activity</Text>
            </Button>
          )}
          {interventionPlanToggle === "yes" &&
            (view ? (
              // Mockup lists each goal as a plain, always-expanded card —
              // no collapse/expand.
              <Box className={classes.vCard}>
                <Text className={classes.vCardHeading}>
                  <IoMdCheckboxOutline /> Intervention Plan Outcomes
                </Text>
                {Array.isArray(goals) &&
                  goals?.map((goalItem, index) => (
                    <Box key={goalItem?.id} className={classes.vAccItem}>
                      <Box className={classes.vGoalHead}>
                        <Text className={classes.vGoalTitle}>
                          Goal {goalItem?.goalNumber ? goalItem.goalNumber : index + 1}
                          {goalItem?.identifiedGoal ? ` · ${goalItem.identifiedGoal}` : ""}
                        </Text>
                        {goalItem?.metGoalIntervention && (
                          <Text
                            component="span"
                            className={`${classes.vMetChip} ${getMetChipClass(goalItem?.metGoalIntervention)}`}
                          >
                            {goalItem?.metGoalIntervention}
                          </Text>
                        )}
                      </Box>
                      {(goalItem?.startTimeGoal || goalItem?.endTimeGoal) && (
                        <Box className={classes.vGoalTimeRow}>
                          <Box className={classes.vRefLine}>
                            <Text className={classes.vRefLineLabel}>Start Time</Text>
                            <Text className={classes.vRefLineVal}>
                              {formatGoalTime(goalItem?.startTimeGoal) || "-"}
                            </Text>
                          </Box>
                          <Box className={classes.vRefLine}>
                            <Text className={classes.vRefLineLabel}>End Time</Text>
                            <Text className={classes.vRefLineVal}>
                              {formatGoalTime(goalItem?.endTimeGoal) || "-"}
                            </Text>
                          </Box>
                        </Box>
                      )}
                      {goalItems[index]?.map((_gi, gIndex) => (
                        <Box className={classes.vPlanRef} key={_gi.id || gIndex}>
                          <Box className={classes.vRefLine}>
                            <Text className={classes.vRefLineLabel}>Objective</Text>
                            <Text className={classes.vRefLineVal}>
                              {_gi?.objectives || "-"}
                            </Text>
                          </Box>
                          <Box className={classes.vRefLine}>
                            <Text className={classes.vRefLineLabel}>Intervention</Text>
                            <Text className={classes.vRefLineVal}>
                              {_gi?.Intervention_Instruction || "-"}
                            </Text>
                          </Box>
                        </Box>
                      ))}
                      <Box className={classes.vDocSec}>
                        <Text className={classes.vDocLabel}>Behavior</Text>
                        <Text className={classes.vDocBody}>
                          {goalItem?.behaviorDescription || "-"}
                        </Text>
                      </Box>
                      <Box className={classes.vDocSec}>
                        <Text className={classes.vDocLabel}>Response</Text>
                        <Text className={classes.vDocBody}>
                          {goalItem?.responseDescription || "-"}
                        </Text>
                      </Box>
                      <Box className={classes.vDocSec}>
                        <Text className={classes.vDocLabel}>Plan</Text>
                        <Text className={classes.vDocBody}>
                          {goalItem?.planDescription || "-"}
                        </Text>
                      </Box>
                    </Box>
                  ))}
              </Box>
            ) : (
            <Box>
              <Accordion
                value={goalsAccordion}
                onChange={(value) => {
                  // if (view === true || edit === true) {
                  //   let data = essentialSupport?.[value];
                  //   handleEssentialTypeChangeForNoteView(
                  //     data?.essentialSupportType,
                  //     data?.howOftenEssentialSupport
                  //   );
                  // }
                  setGoalsAccordion(value);
                }}
                mt={16}
                variant="separated"
                chevron={<IconChevronDown size={34} color="var(--app-text)" />}
                chevronPosition="right"
                chevronSize={20}
                className={classes.essentialAccordion}
                styles={{
                  chevron: {
                    transition: "transform 200ms ease",
                    "&[data-active]": {
                      transform: "rotate(180deg)",
                    },
                  },
                }}
              >
                {Array.isArray(goals) &&
                  goals?.map((goalItem, index) => (
                    <Accordion.Item
                      key={goalItem?.id}
                      value={String(index)}
                      className={classes.essentialAccordionItem}
                    >
                      <Accordion.Control>
                        <Box
                          className={classes.accordionControl}
                          // onClick={handleRecordingConfirm}
                        >
                          <Text color="var(--app-text)" fz={16} fw={500} ff="Inter">
                            Goal {""}
                            {goalItem?.goalNumber
                              ? goalItem.goalNumber
                              : index + 1}
                            {/* {index + 1} */}
                          </Text>
                        </Box>
                      </Accordion.Control>

                      <Accordion.Panel>
                        <Grid
                          gutter={26}
                          sx={{
                            paddingBottom: 26,
                          }}
                          className={classes.mwd}
                        >
                          {!view && (
                            <Grid.Col span={12}>
                              <Box mb={26} className={classes.outcomeDeleteBTN}>
                                {/* <Text
                                                    onClick={() =>
                                                      removeGoal(goalItem?.id)
                                                    }
                                                  >
                                                    <AiOutlineDelete size={20} />
                                                    Delete
                                                  </Text> */}
                              </Box>
                            </Grid.Col>
                          )}
                          <Grid.Col xs={12} sm={12} md={5} lg={5} xl={5}>
                            <TimeInput
                              label="Start Time"
                              variant={view ? "unstyled" : undefined}
                              className={view ? classes.timeDateView : classes.datePicker}
                              icon={
                                <img
                                  style={{ width: "20px" }}
                                  src={"/assets/images/clock.png"}
                                  alt="Icon"
                                />
                              }
                              format="12"
                              value={goalItem?.startTimeGoal || ""}
                              // onChange={(e) => {
                              //   const isSafari =
                              //     /^((?!chrome|android).)*safari/i.test(
                              //       navigator.userAgent
                              //     );
                              //   let time = e.target.value
                              //     .split(":")
                              //     ?.slice(0, 2)
                              //     ?.join(":");
                              //   isSafari
                              //     ? handleEssentialSupportDesc(
                              //         goalItem.id,
                              //         "startTimeGoal",
                              //         time,
                              //         index
                              //       )
                              //     : handleEssentialSupportDesc(
                              //         goalItem.id,
                              //         "startTimeGoal",
                              //         time,
                              //         index
                              //       );
                              // }}
                              disabled={view}
                            />
                          </Grid.Col>
                          <Grid.Col span={2}>
                            <Flex
                              align="center"
                              justify="center"
                              h="100%"
                              pt={28}
                            >
                              <Text fz={25} color="var(--app-text)" fw={400}>
                                -
                              </Text>
                            </Flex>
                          </Grid.Col>
                          <Grid.Col xs={12} sm={12} md={5} lg={5} xl={5}>
                            <TimeInput
                              label="End Time"
                              format="12"
                              variant={view ? "unstyled" : undefined}
                              className={view ? classes.timeDateView : classes.datePicker}
                              icon={
                                <img
                                  style={{ width: "20px" }}
                                  src={"/assets/images/clock.png"}
                                  alt="Icon"
                                />
                              }
                              value={goalItem?.endTimeGoal || ""}
                              // onChange={(e) => {
                              //   const isSafari =
                              //     /^((?!chrome|android).)*safari/i.test(
                              //       navigator.userAgent
                              //     );
                              //   let time = e.target.value
                              //     .split(":")
                              //     ?.slice(0, 2)
                              //     ?.join(":");
                              //   isSafari
                              //     ? handleEssentialSupportDesc(
                              //         goalItem.id,
                              //         "endTimeGoal",
                              //         time,
                              //         index
                              //       )
                              //     : handleEssentialSupportDesc(
                              //         goalItem.id,
                              //         "endTimeGoal",
                              //         time,
                              //         index
                              //       );
                              // }}
                              disabled={view}
                            />
                          </Grid.Col>
                          <Grid.Col xs={12} sm={12} md={10} lg={10} xl={10}>
                            <TextInput
                              id="essential-support-type"
                              size="sm"
                              required
                              // data={goalOptions.filter(
                              //   (g) =>
                              //     !goals.some(
                              //       (gi) =>
                              //         gi.identifiedGoal === g.value &&
                              //         gi.id !== goalItem.id
                              //     )
                              // )}
                              label={"Identified Goals"}
                              className={view ? classes.timeDateView : undefined}
                              placeholder={"Identified Goals"}
                              readOnly={view}
                              variant={view ? "unstyled" : "filled"}
                              value={goalItem?.identifiedGoal || ""}
                              // disabled={true}
                              // onChange={(value) => {
                              //   handleEssentialTypeChange(
                              //     goalItem?.id,
                              //     "identifiedGoal",
                              //     value,
                              //     index
                              //   );
                              // }}
                              // error={
                              //   essentialSupportErrors[index] &&
                              //   !goalItem?.identifiedGoal &&
                              //   "Support Type is required"
                              // }
                              // mx={{ base: 0, sm: 17 }}
                              my={{ base: 26, sm: 0 }}
                              withAsterisk={false}
                              // rightSectionPointerEvents="none"
                              // rightSection={icon}
                            />
                          </Grid.Col>
                          <Grid.Col xs={12} sm={12} md={2} lg={2} xl={2}>
                            <TextInput
                              id="essential-goalItem-outcome-number"
                              size="sm"
                              required
                              // data={goalNumber || []}
                              label={"Goal #"}
                              className={view ? classes.timeDateView : undefined}
                              placeholder={"#"}
                              readOnly={view}
                              value={goalItem?.goalNumber || ""} // ✅ set value
                              // onChange={(value) => {
                              //   handleEssentialNumberChange(
                              //     goalItem?.id,
                              //     "goalNumber",
                              //     value,
                              //     index
                              //   );
                              // }}
                              variant={view ? "unstyled" : "filled"}
                              // mx={{ base: 0, sm: 10 }}
                              // my={{ base: 26, sm: 0 }}
                              withAsterisk={false}
                              // rightSectionPointerEvents="none"
                              // rightSection={icon}
                            />
                          </Grid.Col>
                        </Grid>

                        {goalItems[index]?.map((_gi, gIndex) => (
                          <Grid key={_gi.id} mb={10}>
                            <Grid.Col
                              xs={12}
                              sm={12}
                              md={!view ? 11 : 12}
                              lg={!view ? 11 : 12}
                              xl={!view ? 11 : 12}
                            >
                              <Box className={classes.interventionGoalItem}>
                                <TextInput
                                  id={`essential-goalItem-type-${_gi.id}`}
                                  size="sm"
                                  required
                                  // data={objectivesByGoal.filter(
                                  //   (o) =>
                                  //     !goalItems.some(
                                  //       (g) =>
                                  //         g.objectives === o.value &&
                                  //         g.id !== _gi.id
                                  //     )
                                  // )}
                                  // data={objectivesByGoal}
                                  label="Objective"
                                  className={view ? classes.vDocField : undefined}
                                  variant={view ? "unstyled" : undefined}
                                  placeholder="Objective"
                                  readOnly={view}
                                  value={_gi?.objectives || ""}
                                  // onChange={(value) =>
                                  //   handleGoalActivityChange(
                                  //     _gi.id,
                                  //     "objectives",
                                  //     value,
                                  //     gIndex
                                  //   )
                                  // }
                                  mb={10}
                                  withAsterisk={false}
                                  // rightSectionPointerEvents="none"
                                  // rightSection={icon}
                                />
                                <TextInput
                                  id={`essential-goalItem-frequency-${goalItem.id}`}
                                  size="sm"
                                  required
                                  // data={interventionsByGoal.filter(
                                  //   (i) =>
                                  //     !goalItems.some(
                                  //       (g) =>
                                  //         g.Intervention_Instruction ===
                                  //           i.value && g.id !== _gi.id
                                  //     )
                                  // )}
                                  // data={interventionsByGoal}
                                  label="Intervention"
                                  className={view ? classes.vDocField : undefined}
                                  variant={view ? "unstyled" : undefined}
                                  placeholder="Intervention"
                                  value={_gi?.Intervention_Instruction || ""}
                                  // onChange={(value) =>
                                  //   handleGoalActivityChange(
                                  //     _gi.id,
                                  //     "Intervention_Instruction",
                                  //     value,
                                  //     gIndex
                                  //   )
                                  // }
                                  readOnly={view}
                                  withAsterisk={false}
                                  // rightSectionPointerEvents="none"
                                  // rightSection={icon}
                                />
                              </Box>
                            </Grid.Col>

                            {/* {!view && (
                                                <Grid.Col xs={12} sm={12} md={1} gap={10}>
                                                  <Flex
                                                    direction="column"
                                                    gap={10}
                                                    justify="center"
                                                    align="center"
                                                    h="100%"
                                                  >
                                                    <Button
                                                      onClick={handleAddGoalItem}
                                                      className={
                                                        classes.interventionAddGoalItem
                                                      }
                                                      disabled={view || isAddDisabled}
                                                      sx={{
                                                        opacity:
                                                          view || isAddDisabled ? 0.5 : 1,
                                                        pointerEvents:
                                                          view || isAddDisabled
                                                            ? "none"
                                                            : "auto",
                                                        cursor:
                                                          view || isAddDisabled
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                    >
                                                      <TbPlus
                                                        size={15}
                                                        color="var(--app-text)"
                                                      />
                                                    </Button>
                                                    <Button
                                                      onClick={() =>
                                                        handleRemoveGoalItem(_gi.id)
                                                      }
                                                      className={
                                                        classes.interventionAddGoalItem
                                                      }
                                                      disabled={goalItems.length === 1} // keep at least 1 row
                                                      sx={{
                                                        opacity:
                                                          goalItems.length === 1
                                                            ? 0.5
                                                            : 1,
                                                        pointerEvents:
                                                          goalItems.length === 1
                                                            ? "none"
                                                            : "auto",
                                                        cursor:
                                                          goalItems.length === 1
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                    >
                                                      <TbTrash
                                                        size={15}
                                                        color="var(--app-text)"
                                                      />
                                                    </Button>
                                                  </Flex>
                                                </Grid.Col>
                                              )} */}
                          </Grid>
                        ))}

                        {/* Behavior Description */}
                        <Textarea
                          id="add-note"
                          className={
                            view ? classes.vDocField : classes.essentialDiscriptionArea
                          }
                          variant={view ? "unstyled" : undefined}
                          size="sm"
                          label="Behavior"
                          maxRows={5}
                          minRows={10}
                          placeholder="Enter behavior"
                          value={
                            goalItem?.behaviorDescription?.length > 0
                              ? goalItem?.behaviorDescription
                              : ""
                            // : essentialNotes[index]
                          }
                          onChange={(e) => {
                            handleEssentialSupportDesc(
                              goalItem?.id,
                              "behaviorDescription",
                              e?.target?.value,
                              index
                            );
                            let tempNotesArr = essentialNotes;
                            tempNotesArr.splice(index, 1, e?.target?.value);
                            setEssentialNotes([...tempNotesArr]);
                          }}
                          // disabled={view}
                          readOnly={view}
                          autosize={view}
                        />
                        {/* {!view && (
                                            <>
                                              <AiAssistantChatCard
                                                open={aiAssistantCardOpened}
                                                handleAiAssistantSubmit={
                                                  handleAiAssistantSubmit
                                                }
                                                form={form}
                                                // descriptions={descriptions}
                                                support={goalItem}
                                                messages={goalItem?.message}
                                                sendMessageToOpenAI={sendMessageToOpenAI}
                                                loading={loading}
                                                messageValue={messageValue}
                                                formErrors={formErrors}
                                                setAiAssistantCardOpened={
                                                  setAiAssistantCardOpened
                                                }
                                                essentialSupportIndex={index}
                                              />
                                              {!aiAssistantCardOpened && (
                                                <Flex
                                                  px={19}
                                                  bg={"var(--app-surface-2)"}
                                                  py={8}
                                                  justify="space-between"
                                                  align={"center"}
                                                  gap={12}
                                                  sx={{
                                                    border: "1px solid var(--app-border)",
                                                    borderRadius: "0px 0px 8px 8px",
                                                  }}
                                                >
                                                  <Flex align={"center"} gap={8}>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      Credit Balance:{" "}
                                                    </Text>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      {existingRecord?.planType ===
                                                      "monthly-subscription"
                                                        ? "Unlimited"
                                                        : Number(
                                                            existingRecord?.adminTotalTokens
                                                          )}
                                                    </Text>
                                                  </Flex>
                                                  <Flex align={"center"} gap={8}>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        (existingRecord.active ===
                                                          false &&
                                                          existingRecord.paid === false)
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          (existingRecord.active ===
                                                            false &&
                                                            existingRecord.paid === false)
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={() => {
                                                        handleMicStart("essential");
                                                      }}
                                                    >
                                                      <MicAiSvg
                                                        color={
                                                          view ||
                                                          (existingRecord.adminTotalTokens ===
                                                            "" &&
                                                            existingRecord.planType ===
                                                              "onetime-purchase")
                                                            ? "#A0A0A0"
                                                            : "var(--app-text)"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        !goalItem?.description ||
                                                        goalItem?.description === ""
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={handleAiAssistantSubmit}
                                                    >
                                                      <AutoFillSvg
                                                        color={
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "#A0A0A0"
                                                            : "var(--app-text)"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                  </Flex>
                                                </Flex>
                                              )}
                                            </>
                                          )}
                                          <RecordingControls
                                            isListening={isListening}
                                            recordingTime={recordingTime}
                                            onRedo={handleRedo}
                                            onCancel={handleRecordingCancel}
                                            onConfirm={handleRecordingConfirm}
                                            classes={classes}
                                          /> */}
                        {/* Response Description */}

                        <Textarea
                          id="add-note"
                          className={
                            view ? classes.vDocField : classes.essentialDiscriptionArea
                          }
                          variant={view ? "unstyled" : undefined}
                          size="sm"
                          label="Response"
                          maxRows={5}
                          minRows={10}
                          mt={10}
                          placeholder="Enter Response"
                          value={
                            goalItem?.responseDescription?.length > 0
                              ? goalItem?.responseDescription
                              : ""
                            // : essentialNotes[index]
                          }
                          onChange={(e) => {
                            handleEssentialSupportDesc(
                              goalItem?.id,
                              "responseDescription",
                              e?.target?.value,
                              index
                            );
                            // let tempNotesArr = essentialNotes;
                            // tempNotesArr.splice(
                            //   index,
                            //   1,
                            //   e?.target?.value
                            // );
                            // setEssentialNotes([...tempNotesArr]);
                          }}
                          // disabled={view}
                          readOnly={view}
                          autosize={view}
                        />
                        {/* {!view && (
                                            <>
                                              <AiAssistantChatCard
                                                open={aiAssistantCardOpened}
                                                handleAiAssistantSubmit={
                                                  handleAiAssistantSubmit
                                                }
                                                form={form}
                                                // descriptions={descriptions}
                                                support={goalItem}
                                                messages={goalItem?.message}
                                                sendMessageToOpenAI={sendMessageToOpenAI}
                                                loading={loading}
                                                messageValue={messageValue}
                                                formErrors={formErrors}
                                                setAiAssistantCardOpened={
                                                  setAiAssistantCardOpened
                                                }
                                                essentialSupportIndex={index}
                                              />
                                              {!aiAssistantCardOpened && (
                                                <Flex
                                                  px={19}
                                                  bg={"var(--app-surface-2)"}
                                                  py={8}
                                                  justify="space-between"
                                                  align={"center"}
                                                  gap={12}
                                                  sx={{
                                                    border: "1px solid var(--app-border)",
                                                    borderRadius: "0px 0px 8px 8px",
                                                  }}
                                                >
                                                  <Flex align={"center"} gap={8}>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      Credit Balance:{" "}
                                                    </Text>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      {existingRecord?.planType ===
                                                      "monthly-subscription"
                                                        ? "Unlimited"
                                                        : Number(
                                                            existingRecord?.adminTotalTokens
                                                          )}
                                                    </Text>
                                                  </Flex>
                                                  <Flex align={"center"} gap={8}>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        (existingRecord.active ===
                                                          false &&
                                                          existingRecord.paid === false)
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          (existingRecord.active ===
                                                            false &&
                                                            existingRecord.paid === false)
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={() => {
                                                        handleMicStart("essential");
                                                      }}
                                                    >
                                                      <MicAiSvg
                                                        color={
                                                          view ||
                                                          (existingRecord.adminTotalTokens ===
                                                            "" &&
                                                            existingRecord.planType ===
                                                              "onetime-purchase")
                                                            ? "#A0A0A0"
                                                            : "var(--app-text)"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        !goalItem?.description ||
                                                        goalItem?.description === ""
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={handleAiAssistantSubmit}
                                                    >
                                                      <AutoFillSvg
                                                        color={
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "#A0A0A0"
                                                            : "var(--app-text)"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                  </Flex>
                                                </Flex>
                                              )}
                                            </>
                                          )}
                                          <RecordingControls
                                            isListening={isListening}
                                            recordingTime={recordingTime}
                                            onRedo={handleRedo}
                                            onCancel={handleRecordingCancel}
                                            onConfirm={handleRecordingConfirm}
                                            classes={classes}
                                          /> */}

                        {/* Plan description */}
                        <Textarea
                          id="add-note"
                          className={
                            view ? classes.vDocField : classes.essentialDiscriptionArea
                          }
                          variant={view ? "unstyled" : undefined}
                          size="sm"
                          label="Plan"
                          mt={10}
                          maxRows={5}
                          minRows={10}
                          placeholder="Enter Plan"
                          value={
                            goalItem?.planDescription?.length > 0
                              ? goalItem?.planDescription
                              : ""
                            // : essentialNotes[index]
                          }
                          onChange={(e) => {
                            handleEssentialSupportDesc(
                              goalItem?.id,
                              "planDescription",
                              e?.target?.value,
                              index
                            );
                            // let tempNotesArr = essentialNotes;
                            // tempNotesArr.splice(
                            //   index,
                            //   1,
                            //   e?.target?.value
                            // );
                            // setEssentialNotes([...tempNotesArr]);
                          }}
                          // disabled={view}
                          readOnly={view}
                          autosize={view}
                        />
                        {/* {!view && (
                                            <>
                                              <AiAssistantChatCard
                                                open={aiAssistantCardOpened}
                                                handleAiAssistantSubmit={
                                                  handleAiAssistantSubmit
                                                }
                                                form={form}
                                                support={goalItem}
                                                messages={goalItem?.message}
                                                sendMessageToOpenAI={sendMessageToOpenAI}
                                                loading={loading}
                                                messageValue={messageValue}
                                                formErrors={formErrors}
                                                setAiAssistantCardOpened={
                                                  setAiAssistantCardOpened
                                                }
                                                essentialSupportIndex={index}
                                              />
                                              {!aiAssistantCardOpened && (
                                                <Flex
                                                  px={19}
                                                  bg={"var(--app-surface-2)"}
                                                  py={8}
                                                  justify="space-between"
                                                  align={"center"}
                                                  gap={12}
                                                  sx={{
                                                    border: "1px solid var(--app-border)",
                                                    borderRadius: "0px 0px 8px 8px",
                                                  }}
                                                >
                                                  <Flex align={"center"} gap={8}>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      Credit Balance:{" "}
                                                    </Text>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      {existingRecord?.planType ===
                                                      "monthly-subscription"
                                                        ? "Unlimited"
                                                        : Number(
                                                            existingRecord?.adminTotalTokens
                                                          )}
                                                    </Text>
                                                  </Flex>
                                                  <Flex align={"center"} gap={8}>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        (existingRecord.active ===
                                                          false &&
                                                          existingRecord.paid === false)
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          (existingRecord.active ===
                                                            false &&
                                                            existingRecord.paid === false)
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={() => {
                                                        handleMicStart("essential");
                                                      }}
                                                    >
                                                      <MicAiSvg
                                                        color={
                                                          view ||
                                                          (existingRecord.adminTotalTokens ===
                                                            "" &&
                                                            existingRecord.planType ===
                                                              "onetime-purchase")
                                                            ? "#A0A0A0"
                                                            : "var(--app-text)"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        !goalItem?.description ||
                                                        goalItem?.description === ""
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={handleAiAssistantSubmit}
                                                    >
                                                      <AutoFillSvg
                                                        color={
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "#A0A0A0"
                                                            : "var(--app-text)"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                  </Flex>
                                                </Flex>
                                              )}
                                            </>
                                          )}
                                          <RecordingControls
                                            isListening={isListening}
                                            recordingTime={recordingTime}
                                            onRedo={handleRedo}
                                            onCancel={handleRecordingCancel}
                                            onConfirm={handleRecordingConfirm}
                                            classes={classes}
                                          /> */}
                        <TextInput
                          mt={16}
                          id="about-goal"
                          size="sm"
                          radius={"md"}
                          className={view ? classes.timeDateView : classes.select}
                          variant={view ? "unstyled" : undefined}
                          data={[
                            "Yes",
                            "No",
                            "Goal in progress",
                            "Not Applicable",
                          ]}
                          label="Was this goal met?"
                          placeholder="Select a response"
                          value={goalItem?.metGoalIntervention}
                          // onChange={(value) => {
                          //   handleEssentialSupportDesc(
                          //     goalItem?.id,
                          //     "metGoalIntervention",
                          //     value,
                          //     index
                          //   );
                          // }}
                          disabled={view}
                          rightSectionPointerEvents="none"
                          rightSection={icon}
                        />
                      </Accordion.Panel>
                    </Accordion.Item>
                  ))}
              </Accordion>
            </Box>
            ))}

          {noteType?.custom?.map((value, index) => {
            if (value.field !== "Staff Name") return null;

            const selectedValue = form?.getInputProps(value?.field)?.value;
            const staffOptions = getOptions("Staff", noteType?.custom);
            const selectedIds = Array.isArray(selectedValue)
              ? selectedValue
              : selectedValue
              ? [selectedValue]
              : [];

            const signBoxes = selectedIds
              .map((id) => {
                const staffLabel = staffOptions?.find(
                  (option) => option.value === id
                )?.label;

                if (!staffLabel) return null;

                // Matching signature object
                const signatureData = allSignature?.find(
                  ({ staff, admin }) =>
                    (staff && staff?.id === id) || (admin && admin?.id === id)
                );

                const signatureImage =
                  signatureData?.signature || signatureData?.signatureImage;
                const signatureText = signatureData?.signatureText;

                return (
                  <Box key={`${index}-${id}`} className={classes.vSignBox}>
                    {signatureImage ? (
                      <img
                        src={decrypt(signatureImage)}
                        alt="signature"
                        className={classes.vSignImg}
                      />
                    ) : (
                      <Text className={classes.vSign}>
                        {signatureText || staffLabel}
                      </Text>
                    )}
                    <Text className={classes.vSignSub}>
                      Signed by {staffLabel}
                    </Text>
                  </Box>
                );
              })
              .filter(Boolean);

            if (!signBoxes.length) return null;

            return (
              <Box key={index} className={classes.vCard}>
                <Text className={classes.vCardHeading}>
                  <LuPenLine /> Staff Signature
                </Text>
                {signBoxes}
              </Box>
            );
          })}

          {!view && (
            <SimpleGrid cols={isMobileScreen ? 1 : 2}>
              <Button
                radius={8}
                color="red"
                variant="light"
                onClick={resetForm}
                leftIcon={<IconX />}
                sx={{ marginLeft: "auto", width: isMobileScreen ? "100%" : 122, fontFamily: "Inter" }}
              >
                Cancel
              </Button>
              <Button
                id="save-note-button"
                color="yellow"
                sx={{
                  width: isMobileScreen ? "100%" : 122,
                  marginRight: "auto",
                  fontFamily: "Inter",
                }}
                styles={(theme) => ({
                  root: {
                    color: "var(--app-on-primary)",
                  },
                })}
                radius={8}
                type="submit"
                loading={addNoteLoading}
              >
                Save
              </Button>
            </SimpleGrid>
          )}

          {/* rejection and approved notes */}
          {showRejection && !showRejectedNote && showApprovalControls && (
            <Box className={classes.rejectionContainer}>
              <Box className={classes.rejectionBox}>
                <Box className={classes.rejection} mb={5}>
                  <Text ff={"Inter"} fz={14} fw={500} color="var(--app-text)">
                    Reason of Rejection
                  </Text>
                  <RxCross2
                    size={20}
                    className={classes.crossIcon}
                    onClick={() => handleShowRejection()}
                  />
                </Box>
                <Select
                  size="md"
                  radius="md"
                  label={<div style={{ marginBottom: 5 }}>Reason</div>}
                  placeholder="Select reason"
                  rightSection={<IconChevronDown size={16} />}
                  data={[
                    {
                      value: "Missing Required Information",
                      label: "Missing Required Information",
                    },
                    {
                      value: "No Connection to ISP Goals or Outcome",
                      label: "No Connection to ISP Goals or Outcome",
                    },
                    {
                      value: "Insufficient Detail",
                      label: "Insufficient Detail",
                    },
                    {
                      value: "Incorrect or Missing Dates/Times",
                      label: "Incorrect or Missing Dates/Times",
                    },
                    {
                      value: "Not Aligned with Assigned Shift",
                      label: "Not Aligned with Assigned Shift",
                    },
                  ]}
                  value={noteRejectValue}
                  onChange={(selected) => {
                    setNoteRejectValue(selected);
                    setReasonError("");
                  }}
                  error={reasonError && "Reason field is required"}
                />
                <Textarea
                  rows={6}
                  minRows={3}
                  mt={3}
                  size="md"
                  radius="md"
                  value={noteRejectionDescp}
                  label={
                    <div style={{ marginBottom: 5 }}>
                      Description (Optional)
                    </div>
                  }
                  placeholder="Enter reason of rejection"
                  onChange={(event) =>
                    setNoteRejectionDescp(event.target.value)
                  }
                />
              </Box>
              <Button
                size="md"
                c={"#fff"}
                color="red"
                radius={"md"}
                variant="filled"
                w={"fit-content"}
                onClick={() => {
                  handleReject();
                }}
              >
                Reject
              </Button>
            </Box>
          )}

          {/* {profile?.user?.type === "staff" &&
            profile?.user?.role !== "admin" &&
            noteData?.data?.approvalStatus === "pending" && (
              <Box className={classes.rejectedNote}>
                <Box className={classes.rejectionIconBox}>
                  <MdPendingActions size={30} color="orange" />
                  <Text ff={"Inter"} fz={14} fw={500} color="#000">
                    Note Pending
                  </Text>
                </Box>
              </Box>
            )} */}

          {/* Rejected/Approved status is shown in the vstatuscard at the top
              of the drawer body (isRejectedBadgeVisible/isApprovedBadgeVisible)
              — kept only here, not duplicated. */}
          {!view && canApproveOrReject && (
            <Box className={classes.btns}>
              <Button
                c={"#B42318"}
                size="md"
                color="red"
                radius={"md"}
                variant="light"
                style={{ background: "var(--app-tint-red)" }}
                onClick={() => setShowRejection(true)}
              >
                Reject
              </Button>
              <Button
                size="md"
                c={"var(--app-on-primary)"}
                radius={"md"}
                color="yellow"
                variant="filled"
                onClick={handleApproveClick}
              >
                Approve
              </Button>
            </Box>
          )}

          {/* Sticky footer must be the last child so nothing (e.g. the
              rejection-reason composer above) ever scrolls underneath its
              position:sticky bar and gets visually overlapped by it. */}
          {view && (
            <Box className={classes.viewDrawerFooter}>
              <Button
                variant="default"
                radius={8}
                className={classes.viewDrawerCloseBtn}
                onClick={close}
              >
                Close
              </Button>
              {canApproveOrReject && (
                <>
                  <span style={{ flex: 1 }} />
                  <Button
                    c={"#B42318"}
                    size="md"
                    color="red"
                    radius={"md"}
                    variant="light"
                    style={{ background: "var(--app-tint-red)" }}
                    onClick={() => setShowRejection(true)}
                  >
                    Reject
                  </Button>
                  <Button
                    size="md"
                    c={"var(--app-on-primary)"}
                    radius={"md"}
                    color="yellow"
                    variant="filled"
                    onClick={() => {
                      setShowApproved(true);
                      setShowRejectedNote(false);
                      handleApprove();
                    }}
                  >
                    Approve
                  </Button>
                </>
              )}
            </Box>
          )}
        </form>
      </Drawer>
      {/* </div>
      </div> */}
    </>
  );
};

export default NoteModalNew;
